<template>
  <div class="julat-harga">
    <v-snackbar
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      v-model="snackbar.show"
    >
      {{ snackbar.message }}
    </v-snackbar>

    <PageHeader
      icon="mdi-tag-multiple-outline"
      title="Julat Harga & Kuantiti"
      subtitle="Analisis julat harga, kuantiti dan pengesanan anomali mengikut item"
    />

    <!-- Filters -->
    <!-- <v-card outlined class="mb-4">
      <v-card-text class="py-3">
        <v-row align="center" dense>
          <v-col cols="12" sm="3">
            <v-select
              v-model="filters.negeri"
              :items="filterOptions.negeriList"
              label="Negeri"
              outlined dense clearable hide-details
              @change="onFilterChange"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="3">
            <div class="d-flex align-center" style="gap:8px">
              <v-select
                v-model="pusinganFrom"
                :items="pusinganFromItems"
                label="Pusingan Dari"
                outlined dense hide-details
              ></v-select>
              <span class="text-caption text--secondary">hingga</span>
              <v-select
                v-model="pusinganTo"
                :items="pusinganToItems"
                label="Pusingan Hingga"
                outlined dense hide-details
              ></v-select>
            </div>
          </v-col>
          <v-col cols="12" sm="3">
            <v-text-field
              v-model="filters.search"
              label="Cari Kod Item / Nama"
              placeholder="Taip untuk menapis…"
              prepend-inner-icon="mdi-magnify"
              outlined dense clearable hide-details
              @input="onSearchInput"
              @click:clear="onSearchInput"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3" class="d-flex align-center">
            <v-btn outlined color="grey darken-1" height="40" class="text-none" @click="resetFilters">
              <v-icon small left>mdi-refresh</v-icon>
              Tetapkan Semula
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card> -->
<!-- Summary Cards -->
    <!-- <v-row class="mb-4 mt-6">
      <v-col cols="6" sm="4" md="2" v-for="(card, i) in summaryCards" :key="i">
        <v-card outlined class="pa-3" :style="card.style || ''">
          <div class="overline text--secondary" style="font-size: var(--fs-3xs);letter-spacing:0.06em">{{ card.label }}</div>
          <div class="text-h5 font-weight-bold" :style="{ color: card.color || '' }">{{ card.value }}</div>
          <div class="caption text--secondary">{{ card.sub }}</div>
        </v-card>
      </v-col>
    </v-row> -->
    <!-- Main Table -->
    <v-card outlined class="mb-4">
      <v-card-title class="py-3 d-flex align-center">
        <v-icon small class="mr-2">mdi-table</v-icon>
        <span class="subtitle-1 font-weight-medium">Senarai Item — Julat Harga &amp; Kuantiti</span>
        <v-chip x-small color="grey lighten-3" class="ml-3 font-weight-medium">{{ mainTotal }} item</v-chip>
        <v-spacer></v-spacer>
        <download-excel
          :fetch="exportMainTable"
          type="csv"
          :before-generate="stampNow"
          :name="mainExportName"
        >
          <v-btn color="green darken-2" dark class="text-none">
            <v-icon left>mdi-file-excel</v-icon>
            CSV
          </v-btn>
        </download-excel>
      </v-card-title>
      <!-- Setiap penapis memakai susunan yang SAMA: label eyebrow di atas,
           kawalan di bawah. `align="end"` menjajarkan semua kawalan pada garis
           dasar yang sama walaupun tinggi labelnya berbeza. -->
       <v-card-text class="filter-bar py-3">
        <v-row align="end" dense>
          <v-col cols="12" sm="3">
            <div class="fld__label">Negeri</div>
            <!-- Nilai kosong = tiada tapisan negeri (semua). Label eyebrow di
                 atas menggantikan label terapung, jadi medan kosong akan
                 kelihatan KOSONG tanpa placeholder ini. -->
            <v-select
              v-model="filters.negeri"
              :items="filterOptions.negeriList"
              :disabled="negeriLocked"
              :clearable="!negeriLocked"
              placeholder="Semua negeri"
              outlined dense hide-details
              @change="onNegeriChange"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="3">
            <div class="fld__label">Daerah Pentadbiran</div>
            <!-- Tiada pilihan = tiada tapisan daerah (semua). Senarai daerah
                 bergantung pada negeri, jadi medan ini mati sehingga sebuah
                 negeri dipilih. -->
            <v-autocomplete
              v-model="filters.daerah"
              :items="daerahSelectItems"
              :disabled="!filters.negeri"
              placeholder="Semua daerah"
              multiple outlined dense hide-details clearable
              @change="onFilterChange"
            >
              <template v-slot:selection="{ index }">
                <span v-if="index === 0" class="caption text--secondary">{{ daerahLabel }}</span>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="auto">
            <div class="fld__label">Pusingan</div>
            <div class="d-flex align-center pusingan-range">
              <v-select
                v-model="pusinganFrom"
                :items="pusinganFromItems"
                outlined dense hide-details
                class="pusingan-sel"
              ></v-select>
              <span class="pusingan-dash mx-1">–</span>
              <v-select
                v-model="pusinganTo"
                :items="pusinganToItems"
                outlined dense hide-details
                class="pusingan-sel"
              ></v-select>
            </div>
          </v-col>
          <!-- Takes every column the fixed-width filters leave behind. The reset
               button used to sit beside it and squeezed it to a stub, so the
               button now lives on its own row below. -->
          <v-col cols="12" sm="">
            <div class="fld__label">Cari Kod Item / Nama</div>
            <v-text-field
              v-model="filters.search"
              placeholder="Taip untuk menapis…"
              prepend-inner-icon="mdi-magnify"
              outlined dense clearable hide-details
              @input="onSearchInput"
              @click:clear="onSearchInput"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12" class="d-flex justify-end py-0">
            <v-btn outlined height="40" class="text-none reset-btn" @click="resetFilters">
              <v-icon small left>mdi-refresh</v-icon>
              Tetapkan Semula
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-subtitle class="pt-1 pb-3">Klik item untuk lihat graf &amp; butiran sebutan</v-card-subtitle>

      <v-data-table
        :headers="mainHeaders"
        :items="mainItems"
        :options.sync="mainOptions"
        :server-items-length="mainTotal"
        :loading="mainLoading"
        :footer-props="{ 'items-per-page-options': [10, 25, 50, 100] }"
        dense
        @click:row="selectItem"
        :item-class="mainRowClass"
        style="cursor:pointer"
      >
        <template v-slot:item.kod="{ item }">
          <v-chip x-small label outlined color="teal darken-2" class="font-weight-medium">
            <span v-html="highlight(item.kod)"></span>
          </v-chip>
        </template>
        <template v-slot:item.nama="{ item }">
          <span v-html="highlight(item.nama)"></span>
        </template>
        <template v-slot:item.minH="{ item }">
          <span class="green--text font-weight-medium">{{ fmt(item.minH) }}</span>
        </template>
        <template v-slot:item.maxH="{ item }">
          <span class="red--text font-weight-medium">{{ fmt(item.maxH) }}</span>
        </template>
        <template v-slot:item.minQ="{ item }">
          {{ fmtN(item.minQ) }}
        </template>
        <template v-slot:item.maxQ="{ item }">
          {{ fmtN(item.maxQ) }}
        </template>
        <template v-slot:item.unit="{ item }">
          <span class="grey--text">{{ item.unit }}</span>
        </template>
        <template v-slot:item.count="{ item }">
          <span class="font-weight-medium">{{ fmtN(item.count) }}</span>
        </template>
        <template v-slot:item.statusH="{ item }">
          <v-chip x-small :color="statusColor(item.statusH)" :text-color="statusTextColor(item.statusH)">
            {{ statusLabel(item.statusH) }}
          </v-chip>
        </template>
        <template v-slot:no-data>
          <div class="text-center grey--text pa-8">Tiada rekod dijumpai</div>
        </template>
      </v-data-table>
    </v-card>

    <!-- Tabs: IQR detail + Konsensus 4-Kaedah. Styled (.iqr-tabs) to match the
         teal section-bar look.
         To enable/disable Konsensus 4-Kaedah: flip `showKonsensus` in data(). -->
    <v-tabs
      v-model="activeTab"
      background-color="transparent"
      color="teal darken-2"
      slider-color="teal darken-2"
      class="iqr-tabs mb-3"
    >
      <v-tab class="text-none">
        <v-icon small left>mdi-chart-scatter-plot</v-icon>Analisis IQR — Julat Harga
      </v-tab>
      <v-tab v-if="showKonsensus" class="text-none">
        <v-icon small left>mdi-shield-search</v-icon>Konsensus 4-Kaedah
      </v-tab>
    </v-tabs>
   


    <v-tabs-items v-model="activeTab">
      <!-- ── Tab 0: existing IQR detail ───────────────────────────────────── -->
      <v-tab-item>
        <div v-if="!selectedKod && !detailLoading" class="pt-2">
          <v-card outlined class="mb-4">
            <v-card-text class="text-center py-10 grey--text">
              <v-icon size="48" color="grey lighten-1">mdi-cursor-default-click-outline</v-icon>
              <div class="mt-3">Klik item di atas untuk lihat graf taburan &amp; butiran sebutan (kaedah IQR).</div>
            </v-card-text>
          </v-card>
        </div>

    <!-- Selected item info -->
    <v-card v-if="selectedItem" ref="selectedCard" outlined class="mb-4 selected-item-card">
      <v-card-text class="d-flex align-center flex-wrap py-3">
        <v-avatar size="42" color="teal lighten-4" class="mr-3">
          <v-icon color="teal darken-2">mdi-package-variant-closed</v-icon>
        </v-avatar>
        <div class="mr-6" style="min-width:0">
          <div class="overline teal--text text--darken-2" style="line-height:1;font-size: var(--fs-3xs) !important">Item Dipilih</div>
          <div class="text-subtitle-1 font-weight-bold blue-grey--text text--darken-4 text-truncate">{{ selectedItem.nama }}</div>
          <div class="d-flex flex-wrap align-center mt-1" style="gap:6px">
            <v-chip x-small label outlined color="teal darken-2" class="font-weight-medium">{{ selectedItem.kod }}</v-chip>
            <v-chip v-if="filters.negeri" x-small color="teal lighten-4" text-color="teal darken-3" class="font-weight-medium">
              <v-icon x-small left>mdi-map-marker</v-icon>{{ negeriNameByCode[filters.negeri] || filters.negeri }}
            </v-chip>
            <v-chip v-if="pusinganFrom != null && pusinganTo != null" x-small color="teal lighten-4" text-color="teal darken-3" class="font-weight-medium">
              <v-icon x-small left>mdi-sync</v-icon>Pusingan {{ pusinganFrom === pusinganTo ? pusinganFrom : pusinganFrom + '–' + pusinganTo }}
            </v-chip>
          </div>
        </div>
        <v-spacer></v-spacer>
        <div class="item-metrics">
          <div class="item-metric">
            <div class="im-label">Min Harga</div>
            <div class="im-val green--text text--darken-1">{{ fmt(selectedItem.minH) }}</div>
          </div>
          <div class="item-metric">
            <div class="im-label">Max Harga</div>
            <div class="im-val red--text">{{ fmt(selectedItem.maxH) }}</div>
          </div>
          <div class="item-metric">
            <div class="im-label">Min Kuantiti</div>
            <div class="im-val blue-grey--text text--darken-3">{{ fmtN(selectedItem.minQ) }}</div>
          </div>
          <div class="item-metric">
            <div class="im-label">Max Kuantiti</div>
            <div class="im-val blue-grey--text text--darken-3">{{ fmtN(selectedItem.maxQ) }}</div>
          </div>
          <div class="item-metric">
            <div class="im-label">Unit</div>
            <div class="im-val blue-grey--text text--darken-1">{{ selectedItem.unit }}</div>
          </div>
        </div>
      </v-card-text>
    </v-card>

    <!-- Loading detail (charts + butiran) -->
    <v-card v-if="selectedKod && detailLoading" outlined class="mb-4">
      <v-card-text class="text-center py-10">
        <v-progress-circular indeterminate color="teal" size="48" width="4"></v-progress-circular>
        <div class="mt-3 caption text--secondary">Memuatkan data…</div>
      </v-card-text>
    </v-card>

    <!-- Charts -->
    <v-row v-if="selectedKod && !detailLoading" class="mb-4">
      <v-col cols="12" md="12">
        <v-card ref="cardHarga" outlined>
          <v-card-title class="py-2 subtitle-2">
            <span class="teal--text mr-2">&#9679;</span>
            Taburan Harga (RM Negeri)
            <span class="penapis-ringkas grey--text ml-3">{{ selectedKod }}<template v-if="selectedItem"> — {{ selectedItem.nama }}</template></span>
            <span v-if="hargaPlotNote" class="penapis-ringkas amber--text text--darken-3 ml-2" :title="'Plot disampel untuk prestasi; jumlah penuh ditunjuk dalam jadual & dialog'">({{ hargaPlotNote }})</span>
            <v-spacer></v-spacer>
            <div class="d-flex align-center flex-wrap chart-toggles">
              <span class="overline grey--text mr-1">Mod</span>
              <v-btn-toggle v-model="chartMode.harga" mandatory dense @change="redrawChart('harga')">
                <v-btn value="outlier" class="text-none">Outlier sahaja</v-btn>
              </v-btn-toggle>
            </div>
            <span class="overline grey--text ml-3 zoom-hint">Ctrl + skrol untuk zum</span>
            <v-btn icon class="ml-1" title="Zum keluar" @click="zoomChart('harga', 0.9)">
              <v-icon>mdi-magnify-minus-outline</v-icon>
            </v-btn>
            <v-btn icon title="Zum masuk" @click="zoomChart('harga', 1.1)">
              <v-icon>mdi-magnify-plus-outline</v-icon>
            </v-btn>
            <v-btn icon title="Set semula zum" @click="resetZoom('harga')">
              <v-icon>mdi-magnify-scan</v-icon>
            </v-btn>
            <v-btn icon class="ml-1" :title="isFullscreenHarga ? 'Keluar skrin penuh (ESC)' : 'Skrin penuh'" @click="toggleFullscreen('harga')">
              <v-icon>{{ isFullscreenHarga ? 'mdi-fullscreen-exit' : 'mdi-fullscreen' }}</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="chart-container">
            <canvas ref="chartHarga"></canvas>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="12">
        <v-card ref="cardQty" outlined>
          <v-card-title class="py-2 subtitle-2">
            <span class="teal--text mr-2">&#9679;</span>
            Taburan Kuantiti
            <span class="penapis-ringkas grey--text ml-3">{{ selectedKod }}<template v-if="selectedItem"> — {{ selectedItem.nama }}</template></span>
            <span v-if="qtyPlotNote" class="penapis-ringkas amber--text text--darken-3 ml-2" :title="'Plot disampel untuk prestasi; jumlah penuh ditunjuk dalam jadual & dialog'">({{ qtyPlotNote }})</span>
            <v-spacer></v-spacer>
            <div class="d-flex align-center flex-wrap chart-toggles">
              <span class="overline grey--text mr-1">Mod</span>
              <v-btn-toggle v-model="chartMode.qty" mandatory dense @change="redrawChart('qty')">
                <v-btn value="outlier" class="text-none">Outlier sahaja</v-btn>
              </v-btn-toggle>
            </div>
            <span class="overline grey--text ml-3 zoom-hint">Ctrl + skrol untuk zum</span>
            <v-btn icon class="ml-1" title="Zum keluar" @click="zoomChart('qty', 0.9)">
              <v-icon>mdi-magnify-minus-outline</v-icon>
            </v-btn>
            <v-btn icon title="Zum masuk" @click="zoomChart('qty', 1.1)">
              <v-icon>mdi-magnify-plus-outline</v-icon>
            </v-btn>
            <v-btn icon title="Set semula zum" @click="resetZoom('qty')">
              <v-icon>mdi-magnify-scan</v-icon>
            </v-btn>
            <v-btn icon class="ml-1" :title="isFullscreenQty ? 'Keluar skrin penuh (ESC)' : 'Skrin penuh'" @click="toggleFullscreen('qty')">
              <v-icon>{{ isFullscreenQty ? 'mdi-fullscreen-exit' : 'mdi-fullscreen' }}</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="chart-container">
            <canvas ref="chartQty"></canvas>
          </v-card-text>
        </v-card>
      </v-col>
      <!-- Harga Seunit — the only chart whose outliers mean "suspect", since it is
           the only one that measures price against quantity. Purple bullet to match
           the row tint and legend in the Butiran table below. -->
      <v-col cols="12" md="12">
        <v-card ref="cardUnit" outlined>
          <v-card-title class="py-2 subtitle-2">
            <span class="unit-out-text mr-2">&#9679;</span>
            Taburan Harga Seunit
            <span class="penapis-ringkas grey--text ml-3">{{ selectedKod }}<template v-if="selectedItem"> — {{ selectedItem.nama }}</template></span>
            <span class="penapis-ringkas grey--text ml-2">(RM Negeri ÷ Kuantiti)</span>
            <span v-if="unitPlotNote" class="penapis-ringkas amber--text text--darken-3 ml-2" :title="'Plot disampel untuk prestasi; jumlah penuh ditunjuk dalam jadual & dialog'">({{ unitPlotNote }})</span>
            <v-spacer></v-spacer>
            <div class="d-flex align-center flex-wrap chart-toggles">
              <span class="overline grey--text mr-1">Mod</span>
              <v-btn-toggle v-model="chartMode.unit" mandatory dense @change="redrawChart('unit')">
                <v-btn value="outlier" class="text-none">Outlier sahaja</v-btn>
              </v-btn-toggle>
            </div>
            <span class="overline grey--text ml-3 zoom-hint">Ctrl + skrol untuk zum</span>
            <v-btn icon class="ml-1" title="Zum keluar" @click="zoomChart('unit', 0.9)">
              <v-icon>mdi-magnify-minus-outline</v-icon>
            </v-btn>
            <v-btn icon title="Zum masuk" @click="zoomChart('unit', 1.1)">
              <v-icon>mdi-magnify-plus-outline</v-icon>
            </v-btn>
            <v-btn icon title="Set semula zum" @click="resetZoom('unit')">
              <v-icon>mdi-magnify-scan</v-icon>
            </v-btn>
            <v-btn icon class="ml-1" :title="isFullscreenUnit ? 'Keluar skrin penuh (ESC)' : 'Skrin penuh'" @click="toggleFullscreen('unit')">
              <v-icon>{{ isFullscreenUnit ? 'mdi-fullscreen-exit' : 'mdi-fullscreen' }}</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="chart-container">
            <canvas ref="chartUnit"></canvas>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Drill-down Panel -->
    <v-card v-if="selectedKod && !detailLoading" ref="drillCard" outlined class="mb-4">
      <v-card-title class="py-3 d-flex align-center teal lighten-5">
        <v-avatar size="34" color="teal lighten-4" class="mr-3">
          <v-icon small color="teal darken-2">mdi-cursor-default-click</v-icon>
        </v-avatar>
        <div class="d-flex flex-column" style="min-width:0">
          <span class="overline blue-grey--text text--darken-3 font-weight-bold" style="line-height:1;font-size: var(--fs-3xs) !important">Butiran Sebutan</span>
          <span class="subtitle-1 font-weight-bold text-truncate blue-grey--text text--darken-4" style="line-height:1.25">{{ drillNama }}</span>
        </div>
        <v-chip small color="teal lighten-4" text-color="teal darken-2" class="ml-4 font-weight-medium">
          <v-icon x-small left>mdi-format-list-numbered</v-icon>
          {{ drillTotal }} rekod
        </v-chip>
        <v-spacer></v-spacer>
        <v-btn small text color="blue-grey darken-2" class="text-none" @click="closeDrill">
          <v-icon small left>mdi-close</v-icon>
          Tutup
        </v-btn>
      </v-card-title>
      <v-card-subtitle class="pt-2 pb-3 teal lighten-5 d-flex align-center blue-grey--text text--darken-3" style="margin-top:0">
        <v-icon x-small class="mr-1" color="blue-grey darken-2">mdi-information-outline</v-icon>
        {{ drillMeta }}
      </v-card-subtitle>

      <!-- Sub filters — susunan sama seperti bar penapis utama: label eyebrow
           di atas setiap kawalan, bukan label terapung Vuetify. -->
      <v-card-text class="filter-bar py-2">
        <v-row dense align="end">
          <v-col cols="6" sm="2">
            <div class="fld__label">Cari HID</div>
            <v-text-field
              v-model="drillFilters.hid"
              outlined dense hide-details clearable
              prepend-inner-icon="mdi-pin"
              @input="onHidInput"
            ></v-text-field>
          </v-col>
          <v-col cols="6" sm="2">
            <div class="fld__label">Min Harga (RM)</div>
            <v-text-field
              v-model.number="drillFilters.minH"
              type="number"
              outlined dense hide-details
              @input="onDrillFilterChange"
            ></v-text-field>
          </v-col>
          <v-col cols="6" sm="2">
            <div class="fld__label">Max Harga (RM)</div>
            <v-text-field
              v-model.number="drillFilters.maxH"
              type="number"
              outlined dense hide-details
              @input="onDrillFilterChange"
            ></v-text-field>
          </v-col>
          <v-col cols="6" sm="2">
            <div class="fld__label">Min Kuantiti</div>
            <v-text-field
              v-model.number="drillFilters.minQ"
              type="number"
              outlined dense hide-details
              @input="onDrillFilterChange"
            ></v-text-field>
          </v-col>
          <v-col cols="6" sm="2">
            <div class="fld__label">Max Kuantiti</div>
            <v-text-field
              v-model.number="drillFilters.maxQ"
              type="number"
              outlined dense hide-details
              @input="onDrillFilterChange"
            ></v-text-field>
          </v-col>
          <v-col cols="6" sm="2">
            <div class="fld__label">Penapis Outlier</div>
            <v-select
              v-model="drillFilters.outlierType"
              :items="['Semua', 'Outlier Harga dan Kuantiti', 'Outlier Harga Seunit']"
              outlined dense hide-details clearable
              @change="onDrillFilterChange"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="2">
            <v-btn outlined height="40" class="text-none reset-btn" @click="resetDrillFilters">
              <v-icon small left>mdi-refresh</v-icon>
              Tetapkan Semula
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>

      <!-- Drill stats -->
      <div class="stats-wrap px-4 py-3" v-if="drillStatsData">
        <div class="stat-tile" v-for="(st, i) in drillStatsDisplay" :key="i">
          <div class="stat-label">{{ st.label }}</div>
          <div class="stat-value" :class="st.cls">{{ st.value }}</div>
        </div>
      </div>

      <!-- Anomaly note -->
      <!-- <v-alert
        v-if="anomalyNote"
        :type="anomalyNote.type"
        dense text
        class="mx-4 mb-2"
        style="font-size: var(--fs-xs)"
      >
        {{ anomalyNote.message }}
      </v-alert> -->

      <!-- Drill table -->
      <v-card-text class="pa-0">
        <div class="px-4 py-1 d-flex align-center">
          <span class="caption grey--text">{{ drillTotal }} rekod</span>
          <v-spacer></v-spacer>
          <!-- Not download-excel: this table can be 500k+ rows, and building that
               CSV in the browser from a JSON payload crashes the tab. The server
               streams the CSV and we just save the bytes. -->
          <!-- `loading` alone: it already sets pointer-events:none, so it blocks the
               double-click on its own. Adding `disabled` as well makes Vuetify skip
               setColor(), so the button loses its green background while the loading
               class hides the label — it reads as the button vanishing. -->
          <v-btn
            color="green darken-2" dark class="text-none"
            :loading="drillExporting"
            @click="exportDrillTable"
          >
            <v-icon left>mdi-file-excel</v-icon>
            CSV
          </v-btn>
        </div>
        <!-- Action on the left, colour key on the right. The legend lives in its own
             flex box so that when it wraps (three entries + fences is wide) the
             wrapped lines stay right-aligned instead of jumping to the left margin. -->
        <div class="px-4 pb-3 pt-2 legend-bar caption text--secondary">
          <v-btn x-small outlined color="blue-grey darken-1" class="text-none flex-shrink-0" @click="formulaDialog = true">
            <v-icon x-small left>mdi-calculator-variant-outline</v-icon>
            Cara pengiraan outlier
          </v-btn>
          <div class="legend-items" >
            <span class="legend-item">
              <span class="legend-dot" style="background:#D9534F"></span>
              <span class="red--text font-weight-bold">RM Negeri</span>
              <span class="legend-sep">outlier harga</span>
              <span v-if="hargaFence" class="legend-fence">{{ fenceText(hargaFence, fmt) }}</span>
            </span>
            <span class="legend-item">
              <span class="legend-dot" style="background:#F57C00"></span>
              <span class="orange--text font-weight-bold">Kuantiti</span>
              <span class="legend-sep">outlier kuantiti</span>
              <span v-if="qtyFence" class="legend-fence">{{ fenceText(qtyFence, fmtN) }}</span>
            </span>
            <!-- Forces the seunit entry onto its own line. A <br> does nothing here:
                 inside a flex container it is just another zero-size flex item. -->
            <span class="legend-break"></span>
            <span class="legend-item">
              <span class="legend-dot" style="background:#7E57C2"></span>
              <span class="unit-out-text font-weight-bold">Harga Seunit</span>
              <span class="legend-sep">outlier harga seunit</span>
              <span v-if="unitFence" class="legend-fence">{{ fenceText(unitFence, fmt) }}</span>
            </span>
          </div>
        </div>

        <!-- Guide only: the two cell colours answer a different question than the row
             colour, so the rule is spelled out with the two worked examples side by
             side rather than buried in a paragraph. -->
        <!-- <div class="px-4 pb-3">
          <div class="why-note">
            <span class="why-badge">
              <v-icon small color="deep-purple darken-1">mdi-lightbulb-on-outline</v-icon>
            </span>
            <div class="why-body">
              <div class="why-title">Mengapa hanya sesetengah baris berwarna?</div>
              <div class="why-text">
                <strong>RM Negeri</strong> dan <strong>Kuantiti</strong> dinilai secara berasingan, jadi belian
                bersaiz besar boleh melepasi julatnya walaupun kadarnya normal. Hanya
                <strong>Harga Seunit</strong> (RM Negeri&nbsp;÷&nbsp;Kuantiti) menilai harga berbanding kuantiti —
                itu sebabnya ia sahaja yang mewarnakan baris.
              </div>
              <div class="why-egs">
                <span class="why-eg why-eg--ok">
                  <v-icon x-small class="mr-1">mdi-check-circle-outline</v-icon>
                  RM 119.70 ÷ 30 = <b>RM 3.99</b> seunit — normal
                </span>
                <span class="why-eg why-eg--out">
                  <v-icon x-small class="mr-1">mdi-alert-circle-outline</v-icon>
                  RM 37.90 ÷ 1 = <b>RM 37.90</b> seunit — outlier
                </span>
              </div>
            </div>
          </div>
        </div> -->

        <v-data-table
          :headers="drillHeaders"
          :items="drillItemsDisplay"
          :options.sync="drillOptions"
          :server-items-length="drillTotal"
          :loading="drillLoading"
          :footer-props="{ 'items-per-page-options': [10, 25, 50, 100] }"
          :item-class="drillRowClass"
          dense
        >
          <template v-slot:item.hid="{ item }">
            <v-chip x-small color="teal lighten-4" text-color="teal darken-2">{{ item.hid }}</v-chip>
          </template>
          <template v-slot:item.kod="{ item }">
            <v-chip x-small label outlined color="teal darken-2" class="font-weight-medium">{{ item.kod }}</v-chip>
          </template>
          <template v-slot:item.nama="{ item }">
            <span  :title="item.nama">{{ item.nama }}</span>
          </template>
          <template v-slot:item.negeri="{ item }">
            <span class="grey--text">{{ negeriNameByCode[item.negeri] || item.negeri }}</span>
          </template>
          <!-- "Batu Pahat (01)" — the DP code is what appears in the filter and in
               the CSV, so show it alongside the name. Falls back to the bare code
               when lampiran_daerah has no name for it. -->
          <template v-slot:item.daerah="{ item }">
            <span class="grey--text">{{ item.daerahNama ? item.daerahNama + ' (' + item.daerah + ')' : item.daerah }}</span>
          </template>
          <template v-slot:item.pusingan="{ item }">
            <span class="grey--text caption">{{ item.pusingan }}</span>
          </template>
          <template v-slot:item.rmNegeri="{ item }">
            <span :class="{ 'red--text font-weight-bold': item.isHargaOutlier }">{{ fmt(item.rmNegeri) }}</span>
          </template>
          <template v-slot:item.rmHQ="{ item }">
            <span class="grey--text">{{ fmt(item.rmHQ) }}</span>
          </template>
          <template v-slot:item.kuantiti="{ item }">
            <span :class="{ 'orange--text font-weight-bold': item.isQtyOutlier }">{{ fmtN(item.kuantiti) }}</span>
          </template>
          <template v-slot:item.unitPrice="{ item }">
            <span :class="item.isUnitOutlier ? 'unit-out-text font-weight-bold' : 'blue-grey--text text--darken-2'">{{ fmt(unitPrice(item)) }}</span>
          </template>
          <template v-slot:item.unit="{ item }">
            <span class="grey--text">{{ (selectedItem && selectedItem.unit) || item.unit }}</span>
          </template>
          <template v-slot:item.flag="{ item }">
            <v-chip v-if="getFlag(item)" x-small
              :color="item.isUnitOutlier ? 'deep-purple lighten-5' : getFlag(item).includes('Harga') ? 'red lighten-4' : 'orange lighten-4'"
              :text-color="item.isUnitOutlier ? 'deep-purple' : getFlag(item).includes('Harga') ? 'red' : 'orange'"
            >
              {{ getFlag(item) }}
            </v-chip>
            <span v-else class="grey--text">—</span>
          </template>
          <template v-slot:no-data>
            <div class="text-center grey--text pa-6">Tiada rekod dalam julat penapis</div>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
      </v-tab-item>

      <!-- ── Tab 1: Konsensus 4-Kaedah (separate component) ───────────────── -->
      <v-tab-item v-if="showKonsensus">
        <div class="pt-2">
          <konsensus-kaedah
            :kod="selectedKod"
            :negeri="filters.negeri"
            :pusingan="pusinganParam()"
            :dp="daerahParam"
            :active="activeTab === 1"
            @error="onConsensusError"
          ></konsensus-kaedah>
        </div>
      </v-tab-item>
    </v-tabs-items>

    <!-- Formula explainer dialog -->
    <v-dialog v-model="formulaDialog" max-width="780" scrollable>
      <v-card v-if="calcExplain">
        <v-card-title class="subtitle-1 font-weight-bold blue-grey--text text--darken-3 py-3">
          <v-icon left color="teal darken-2">mdi-function-variant</v-icon>
          Cara Pengiraan Outlier — Kaedah IQR
          <v-spacer></v-spacer>
          <v-btn icon small @click="formulaDialog = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider></v-divider>

        <v-card-text class="py-4">
          <!-- General method -->
          <div class="formula-box mb-4">
            <div class="caption font-weight-bold blue-grey--text text--darken-2 mb-2">
              Julat Antara Kuartil (Interquartile Range)
            </div>
            <ol class="formula-steps caption mb-0">
              <li>Susun semua nilai dari kecil ke besar.</li>
              <li><b>Q1</b> = kuartil pertama (kedudukan 25%).</li>
              <li><b>Median</b> = nilai tengah (50%).</li>
              <li><b>Q3</b> = kuartil ketiga (kedudukan 75%).</li>
              <li><b>IQR</b> = Q3 − Q1.</li>
              <li><b>Had Bawah</b> = Q1 − 1.5 × IQR</li>
              <li><b>Had Atas</b> = Q3 + 1.5 × IQR</li>
              <li>
                Nilai <b>&lt; Had Bawah</b> atau <b>&gt; Had Atas</b> ditanda sebagai
                <span class="red--text font-weight-bold">outlier</span>.
              </li>
            </ol>
          </div>

          <!-- Per-metric breakdown -->
          <div v-for="b in calcExplain" :key="b.key" class="metric-block mb-4">
            <div class="d-flex align-center mb-2">
              <span class="legend-dot" :style="{ background: b.color }"></span>
              <span class="subtitle-2 font-weight-bold blue-grey--text text--darken-3">{{ b.title }}</span>
              <v-chip x-small class="ml-2" color="grey lighten-3">{{ b.n }} rekod</v-chip>
            </div>

            <div class="calc-grid mb-2">
              <div class="calc-cell"><span class="cl">Min</span><span class="cv">{{ fmtBy(b.isMoney, b.min) }}</span></div>
              <div class="calc-cell"><span class="cl">Q1 (25%)</span><span class="cv">{{ fmtBy(b.isMoney, b.q1) }}</span></div>
              <div class="calc-cell"><span class="cl">Median (50%)</span><span class="cv">{{ fmtBy(b.isMoney, b.median) }}</span></div>
              <div class="calc-cell"><span class="cl">Q3 (75%)</span><span class="cv">{{ fmtBy(b.isMoney, b.q3) }}</span></div>
              <div class="calc-cell"><span class="cl">Max</span><span class="cv">{{ fmtBy(b.isMoney, b.max) }}</span></div>
              <div class="calc-cell"><span class="cl">IQR</span><span class="cv">{{ fmtBy(b.isMoney, b.iqr) }}</span></div>
            </div>

            <div class="calc-formula caption">
              <div>
                <b>IQR</b> = Q3 − Q1 = {{ fmtBy(b.isMoney, b.q3) }} − {{ fmtBy(b.isMoney, b.q1) }} =
                <b>{{ fmtBy(b.isMoney, b.iqr) }}</b>
              </div>
              <div>
                <b>Had Bawah</b> = Q1 − 1.5 × IQR = {{ fmtBy(b.isMoney, b.q1) }} − 1.5 × {{ fmtBy(b.isMoney, b.iqr) }} =
                <b class="green--text text--darken-2">{{ fmtBy(b.isMoney, b.lowerClamped) }}</b>
                <span v-if="b.lowerNegative" class="grey--text ml-1">
                  (dihadkan pada {{ fmtBy(b.isMoney, 0) }} — hasil kiraan
                  <em>nilai negatif</em> tidak munasabah bagi
                  {{ b.isMoney ? 'harga' : 'kuantiti' }})
                </span>
              </div>
              <div>
                <b>Had Atas</b> = Q3 + 1.5 × IQR = {{ fmtBy(b.isMoney, b.q3) }} + 1.5 × {{ fmtBy(b.isMoney, b.iqr) }} =
                <b class="red--text">{{ fmtBy(b.isMoney, b.upper) }}</b>
              </div>
              <div class="mt-1">
                Outlier: nilai &lt; {{ fmtBy(b.isMoney, b.lowerClamped) }} atau &gt; {{ fmtBy(b.isMoney, b.upper) }}
                <template v-if="b.outlierCount != null">— <b>{{ b.outlierCount }}</b> rekod ditanda.</template>
              </div>
              <!-- Only the seunit block explains itself: it is the one that decides
                   whether a row is coloured, so users need to know why. -->
              <div v-if="b.key === 'unit'" class="mt-1 unit-out-text">
                Ini satu-satunya ukuran yang menilai harga <b>berbanding kuantiti</b>, jadi ia yang
                mewarnakan baris dalam jadual. Rekod bersaiz besar (contoh 30 unit) boleh melepasi
                julat RM Negeri tanpa menjadi outlier di sini, kerana kadar seunitnya masih normal.
              </div>
            </div>
          </div>

          <v-alert dense text type="info" class="caption mb-0" style="font-size: var(--fs-xs)">
            Kuartil harga diambil daripada pengiraan pelayan (sepadan dengan kad statistik di atas);
            kuantiti dikira di pelayar dengan kaedah IQR yang sama. Had Bawah / Had Atas di sini ialah
            sempadan outlier yang sama dengan petunjuk (legend) di bawah jadual.
          </v-alert>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Chart from "chart.js";
// zoom / pan support (Chart.js v2). hammerjs powers drag-pan & pinch-zoom.
import "hammerjs";
import "chartjs-plugin-zoom";
import {
  fetchMainTable,
  fetchDrillTable,
  fetchMainTableExport,
  fetchDrillTableExport,
  getFilterOptions,
  calcStats,
} from "./julatHargaData";
import KonsensusKaedah from "./KonsensusKaedah.vue";
import getPusingan from "@/services/pusingan";
import lookupField from "@/services/lookupField";
import { negeriLock } from "@/services/negeriScope";

const pusinganSvc = new getPusingan();
const lookupSvc = new lookupField();

// ──────────────────────────────────────────────────────────────────────────────
// CARA GUNA API (uncomment axios dan ganti import di atas):
//
// import axios from "../../plugins/axios";
//
// Contoh panggilan API dalam fetchMainData():
//
//   async fetchMainData() {
//     this.mainLoading = true;
//     const { page, itemsPerPage, sortBy, sortDesc } = this.mainOptions;
//     const res = await axios.get(
//       `${process.env.VUE_APP_API_URL}/JulatHarga/getItems`,
//       {
//         params: {
//           page, itemsPerPage,
//           negeri: this.filters.negeri || '',
//           pusingan: this.filters.pusingan || '',
//           kodItem: this.filters.kodItem || '',
//           sortBy: sortBy[0] || '',
//           sortDesc: sortDesc[0] || false,
//         },
//         headers: { Authorization: "Bearer " + localStorage.getItem("token") },
//       }
//     );
//     this.mainItems = res.data.items;
//     this.mainTotal = res.data.total;
//     this.summary = { anomCount: res.data.anomCount, warnCount: res.data.warnCount, totalRecords: res.data.totalRecords };
//     this.mainLoading = false;
//   },
//
// Contoh tukar URL API sahaja:
//   axios.get(`${process.env.VUE_APP_API_URL}/api/v2/julat-harga`)
//   axios.get(`https://your-api-domain.com/api/julat-harga`)
//   axios.get(`http://localhost:8000/api/julat-harga`)
//
// ──────────────────────────────────────────────────────────────────────────────

export default {
  name: "julatHarga",
  components: { KonsensusKaedah },
  data: () => ({
    snackbar: { show: false, message: "", color: "success", timeout: 3000 },

    // Detail tabs: 0 = IQR (existing), 1 = Konsensus 4-Kaedah
    activeTab: 0,
    // ── Feature toggle: set to false to temporarily hide the Konsensus 4-Kaedah
    //    tab (the tab button, its content, and the heavy query are all disabled).
    showKonsensus: false,

    // Filters
    // filters.pusingan stays an array of the selected pusingan codes (so
    // pusinganParam(), export slugs and the Konsensus prop work unchanged), but
    // it's now driven by a From–To range instead of a multi-select.
    filters: { negeri: null, pusingan: [], daerah: [], search: '' },
    negeriLocked: false,   // true for PP/PO/FE/DE → negeri pinned to own kodneg
    filterOptions: { negeriList: [], pusinganList: [], kodItemList: [] },
    // Every { NG, DP, NamaDP } row, fetched once on mount. The whole table is ~160
    // rows, so it's cheaper to hold it and filter by negeri in a computed than to
    // re-hit /lookup/getDP each time the negeri changes.
    dpAll: [],
    // Pusingan range bounds (numeric). Default to first–last available pusingan.
    pusinganFrom: null,
    pusinganTo: null,
    searchDebounce: null,
    // coalesce the two-tick sortBy/sortDesc bursts from v-data-table header clicks
    mainOptionsTimer: null,
    drillOptionsTimer: null,
    // monotonic request sequence — guards against a slower in-flight fetch
    // resolving after a newer one and overwriting the table with stale rows
    mainReqSeq: 0,
    drillReqSeq: 0,
    exportStampVal: '',   // "YYYYMMDD-HHMM" set fresh before each CSV download

    // Main table
    mainItems: [],
    mainTotal: 0,
    mainLoading: false,
    mainOptions: { page: 1, itemsPerPage: 10, sortBy: [], sortDesc: [] },
    mainHeaders: [
      { text: 'Kod Item', value: 'kod', width: 120 },
      { text: 'Nama / Keterangan', value: 'nama' },
      { text: 'Min Harga (RM)', value: 'minH', align: 'end', width: 130 },
      { text: 'Max Harga (RM)', value: 'maxH', align: 'end', width: 130 },
      { text: 'Min Kuantiti', value: 'minQ', align: 'end', width: 110 },
      { text: 'Max Kuantiti', value: 'maxQ', align: 'end', width: 110 },
      { text: 'Unit', value: 'unit', width: 80 },
      // record count per item — server-sorted via a ClickHouse ranking (see getItems)
      { text: 'Bil. Rekod', value: 'count', align: 'end', width: 110 },
//      { text: 'Status Harga', value: 'statusH', align: 'center', width: 120 },
    ],

    // Summary
    summary: { anomCount: 0, warnCount: 0, totalRecords: 0 },

    // Drill-down
    selectedKod: null,
    selectedItem: null,
    drillNama: '',
    drillUnit: '',
    drillItems: [],
    detailLoading: false,
    pinnedHid: null,
    pinnedRecords: [],
    allDrillRecords: [],
    hargaBounds: null,
    qtyBounds: null,
    unitBounds: null,
    drillTotal: 0,
    drillLoading: false,
    drillExporting: false,   // CSV download in flight (can take seconds on a big item)
    drillOptions: { page: 1, itemsPerPage: 10, sortBy: [], sortDesc: [] },
    drillFilters: { hid: null, outlierType: 'Semua', minH: null, maxH: null, minQ: null, maxQ: null },
    drillStatsData: null,
    drillHeaders: [
      { text: 'HID', value: 'hid', width: 90 },
      { text: 'Kod Item', value: 'kod', width: 110 },
      { text: 'Keterangan', value: 'nama' },
      // Negeri, Daerah & Pusingan are enriched from MySQL after the ClickHouse
      // query, so the server cannot sort by them — disable the sort arrows.
      { text: 'Negeri', value: 'negeri', width: 120, sortable: false },
      { text: 'Daerah', value: 'daerah', width: 140, sortable: false },
      { text: 'Pusingan', value: 'pusingan', width: 100, sortable: false },
      { text: 'RM Negeri', value: 'rmNegeri', align: 'end', width: 110 },
      { text: 'RM HQ', value: 'rmHQ', align: 'end', width: 100 },
      { text: 'Kuantiti', value: 'kuantiti', align: 'end', width: 100 },
      // Harga seunit = RM Negeri ÷ Kuantiti. Server computes & sorts this
      // (sortBy: 'unitPrice') so the arrows reflect the full dataset.
      { text: 'Harga Seunit (RM)', value: 'unitPrice', align: 'end', width: 130 },
      { text: 'Unit', value: 'unit', width: 70 },
      // { text: 'Flag', value: 'flag', align: 'center', width: 110, sortable: false },
    ],

    // Charts. Three modes: 'harga' | 'qty' | 'unit' — see chartCfg().
    chartH: null,
    chartQ: null,
    chartU: null,
    isFullscreenHarga: false,
    isFullscreenQty: false,
    isFullscreenUnit: false,
    // View mode per chart. 'outlier' (Outlier sahaja) — the only remaining mode.
    chartMode: { harga: 'outlier', qty: 'outlier', unit: 'outlier' },
    // Cached datasets so a mode toggle can redraw without refetching
    chartData: { harga: null, qty: null, unit: null },

    // Debounce timer
    drillFilterTimer: null,

    // Formula explainer dialog
    formulaDialog: false,
    // Authoritative outlier records/counts from the server (same logic as Penapis Outlier)
    totalAll: 0,
    outlierCountHarga: 0,
    outlierCountQty: 0,
    outlierCountUnit: 0,
    outlierRecsHarga: [], // ALL harga-outlier records — plotted in full on the chart
    outlierRecsQty: [],   // ALL kuantiti-outlier records
    outlierRecsUnit: [],  // ALL harga-seunit-outlier records
  }),

  computed: {
    todayStr() {
      return new Date().toISOString().slice(0, 10);
    },
    // Pusingan range helpers ───────────────────────────────────────────────
    // Available pusingan as { num, raw } sorted numerically. `raw` preserves the
    // original list value (string/number) so pusinganParam() sends exactly what
    // the backend expects.
    pusinganNums() {
      return (this.filterOptions.pusinganList || [])
        .map(p => ({ num: parseInt(p, 10), raw: p }))
        .filter(o => !isNaN(o.num))
        .sort((a, b) => a.num - b.num);
    },
    // "From" = any available pusingan; "To" = only those >= the chosen From.
    pusinganFromItems() {
      return this.pusinganNums.map(o => ({ text: String(o.num).padStart(2, "0"), value: o.num }));
    },
    pusinganToItems() {
      const lo = this.pusinganFrom == null ? -Infinity : this.pusinganFrom;
      return this.pusinganNums.filter(o => o.num >= lo).map(o => ({ text: String(o.num).padStart(2, "0"), value: o.num }));
    },
    summaryCards() {
      return [
        { label: 'Jumlah Item', value: this.mainTotal, sub: 'kod unik', color: '' },
        { label: 'Jumlah Rekod', value: this.summary.totalRecords, sub: 'sebutan pembekal', color: '' },
        { label: 'Anomali Harga', value: this.summary.anomCount, sub: 'perlu siasatan', color: '#2563eb', style: 'border-color:#bfdbfe;background:#eff6ff' },
        { label: 'Perlu Semak', value: this.summary.warnCount, sub: '1 outlier', color: '#d97706', style: 'border-color:#fde68a' },
        { label: 'Normal', value: this.mainTotal - this.summary.anomCount - this.summary.warnCount, sub: 'dalam julat', color: '#16a34a', style: 'border-color:#bbf7d0' },
      ];
    },
    negeriNameByCode() {
      // map negeri code -> name using the filter list (getDetails returns codes like "01")
      const map = {};
      (this.filterOptions.negeriList || []).forEach(o => {
        if (o && typeof o === 'object' && 'value' in o) map[o.value] = o.text;
      });
      return map;
    },
    // ── Daerah Pentadbiran ───────────────────────────────────────────────────
    // DP codes restart at 01 in every negeri, so the list is always scoped to the
    // selected negeri. No negeri selected → no options (the field is disabled).
    daerahSelectItems() {
      const ng = this.filters.negeri;
      if (!ng) return [];
      // /lookup/getDP returns rows unordered — sort by the numeric DP code so the
      // list reads 01, 02, 03… rather than in table order.
      return this.dpAll
        .filter(d => d.NG === ng)
        .sort((a, b) => (parseInt(a.DP, 10) || 0) - (parseInt(b.DP, 10) || 0))
        .map(d => ({ text: d.NamaDP || d.DP, value: d.DP }));
    },
    daerahNameByCode() {
      const map = {};
      this.daerahSelectItems.forEach(o => { map[o.value] = o.text; });
      return map;
    },
    // Single-chip summary shown in the closed select, so a long multi-selection
    // doesn't blow the filter bar's height out.
    daerahLabel() {
      const sel = this.filters.daerah;
      if (!sel.length) return '';
      if (sel.length === 1) return this.daerahNameByCode[sel[0]] || sel[0];
      return `${sel.length} daerah dipilih`;
    },
    // Wire format for the backend `dp` param: '' = semua daerah.
    daerahParam() {
      return this.filters.daerah.join(',');
    },
    // "menunjukkan N drpd M" note when the plotted outlier set was downsampled.
    hargaPlotNote() {
      const shown = this.outlierRecsHarga.length, total = this.outlierCountHarga;
      return total > shown ? `menunjukkan ${this.fmtN(shown)} drpd ${this.fmtN(total)} outlier` : '';
    },
    qtyPlotNote() {
      const shown = this.outlierRecsQty.length, total = this.outlierCountQty;
      return total > shown ? `menunjukkan ${this.fmtN(shown)} drpd ${this.fmtN(total)} outlier` : '';
    },
    unitPlotNote() {
      const shown = this.outlierRecsUnit.length, total = this.outlierCountUnit;
      return total > shown ? `menunjukkan ${this.fmtN(shown)} drpd ${this.fmtN(total)} outlier` : '';
    },
    // ── Export filenames (encode active filters + timestamp) ─────────────────
    // The pusingan filter is a contiguous From–To range, so name the range itself
    // ("3-5") rather than a count ("3of12") — matches the Jadual Awalan pages.
    pusinganSlug() {
      const all = (this.filterOptions.pusinganList || []).length;
      const sel = this.filters.pusingan.length;
      if (all === 0 || sel === all) return 'semua';
      if (sel === 0) return 'none';
      const lo = this.pusinganFrom, hi = this.pusinganTo;
      if (lo == null || hi == null) return 'semua';
      return lo === hi ? `${lo}` : `${lo}-${hi}`;
    },
    // Human-readable negeri for filenames — filters.negeri holds a code ("01"),
    // so resolve it through the lookup rather than leaking the raw code.
    negeriSlug() {
      const code = this.filters.negeri;
      if (!code) return 'semua';
      return this.slug(this.negeriNameByCode[code] || code);
    },
    // Empty selection = semua daerah, so the filename says so rather than listing
    // every DP code. One daerah is named; more than one is counted.
    daerahSlug() {
      const sel = this.filters.daerah;
      if (!sel || !sel.length) return 'semua';
      if (sel.length === 1) return this.slug(this.daerahNameByCode[sel[0]] || sel[0]);
      return `${sel.length}dp`;
    },
    mainExportName() {
      const parts = ['julat-harga-item'];
      parts.push('negeri-' + this.negeriSlug);
      parts.push('dp-' + this.daerahSlug);
      parts.push('p-' + this.pusinganSlug);
      if (this.filters.search && this.filters.search.trim()) {
        parts.push('cari-' + this.slug(this.filters.search));
      }
      parts.push(this.exportStampVal || this.makeStamp());
      return parts.join('_') + '.csv';
    },
    drillExportName() {
      const parts = ['butiran-sebutan', this.slug(this.selectedKod || 'item')];
      parts.push('negeri-' + this.negeriSlug);
      parts.push('dp-' + this.daerahSlug);
      parts.push('p-' + this.pusinganSlug);
      if (this.drillFilters.outlierType && this.drillFilters.outlierType !== 'Semua') {
        parts.push('outlier');
      }
      if (this.drillFilters.hid) parts.push('hid-' + this.slug(this.drillFilters.hid));
      parts.push(this.exportStampVal || this.makeStamp());
      return parts.join('_') + '.csv';
    },
    drillItemsDisplay() {
      // all records sharing the searched/clicked HID stay on top of the current page
      if (!this.pinnedRecords.length) return this.drillItems;
      const pinnedHids = new Set(this.pinnedRecords.map(r => String(r.hid)));
      const rest = this.drillItems.filter(r => !pinnedHids.has(String(r.hid)));
      return [...this.pinnedRecords, ...rest];
    },
    drillMeta() {
      if (!this.selectedKod) return '';
      // prefer the unit name from the clicked main-table row (getDetails returns a code like "01")
      const unit = (this.selectedItem && this.selectedItem.unit) || this.drillUnit;
      return `${this.selectedKod} · ${this.drillTotal} rekod · unit: ${unit}`;
    },
    drillStatsDisplay() {
      const s = this.drillStatsData;
      if (!s) return [];
      return [
        { label: 'Min Harga', value: this.fmt(s.minH), cls: 'green--text' },
        // { label: 'Q1 Harga', value: this.fmt(s.q1H), cls: '' },
        // { label: 'Median Harga', value: this.fmt(s.medianH), cls: 'blue--text' },
        // { label: 'Q3 Harga', value: this.fmt(s.q3H), cls: '' },
        { label: 'Max Harga', value: this.fmt(s.maxH), cls: 'red--text' },
        // { label: 'IQR Harga', value: this.fmt(s.iqrH), cls: 'orange--text' },
        { label: 'Min Kuantiti', value: this.fmtN(s.minQ), cls: '' },
        { label: 'Max Kuantiti', value: this.fmtN(s.maxQ), cls: '' },
        { label: 'Jumlah Rekod', value: this.drillTotal, cls: 'blue--text' },
      ];
    },
    // IQR fences = the actual outlier rule: value < (Q1 − 1.5·IQR) or > (Q3 + 1.5·IQR).
    // Both harga and kuantiti now use the server's FULL-dataset bounds (qtyBounds is
    // populated from the API stats), so the fences match the stat tiles and table.
    hargaFence() {
      const s = this.drillStatsData;
      if (!s || s.q1H == null || s.q3H == null) return null;
      const iqr = s.iqrH != null ? s.iqrH : (s.q3H - s.q1H);
      return { lower: s.q1H - 1.5 * iqr, upper: s.q3H + 1.5 * iqr };
    },
    qtyFence() {
      const q = this.qtyBounds;
      if (!q || q.q1 == null || q.q3 == null) return null;
      return { lower: q.lower, upper: q.upper };
    },
    // Harga Seunit fence — the only one that judges price AGAINST quantity, so it
    // is what drives the row highlight (the other two colour their own cell only).
    unitFence() {
      const s = this.drillStatsData;
      if (!s || s.unitLower == null || s.unitUpper == null) return null;
      return { lower: s.unitLower, upper: s.unitUpper };
    },
    // Step-by-step IQR breakdown shown in the formula dialog.
    //
    // Q1 − 1.5 × IQR goes negative whenever the spread is wide relative to Q1, and a
    // negative ringgit or quantity is meaningless. Each block therefore carries both
    // the raw arithmetic result and a 0-clamped value for display; the template shows
    // the clamped one and explains the clamp, so the equation on screen stays honest.
    // Detection is untouched — no record has a negative harga/kuantiti, so a fence of
    // −5 and a fence of 0 flag exactly the same rows.
    calcExplain() {
      const n = this.totalAll || (this.allDrillRecords || []).length;
      const s = this.drillStatsData;
      const q = this.qtyBounds;
      const blocks = [];
      if (s && s.q1H != null && s.q3H != null) {
        const iqr = s.iqrH != null ? s.iqrH : (s.q3H - s.q1H);
        blocks.push({
          key: 'harga', title: 'Harga (RM Negeri)', isMoney: true, color: '#D9534F',
          n,
          min: s.minH, q1: s.q1H, median: s.medianH, q3: s.q3H, max: s.maxH, iqr,
          lower: s.q1H - 1.5 * iqr, upper: s.q3H + 1.5 * iqr,
          outlierCount: this.outlierCountHarga,
        });
      }
      if (q && q.q1 != null && q.q3 != null) {
        blocks.push({
          key: 'qty', title: 'Kuantiti', isMoney: false, color: '#F57C00',
          n,
          min: q.min, q1: q.q1, median: q.median, q3: q.q3, max: q.max, iqr: q.iqr,
          lower: q.lower, upper: q.upper,
          outlierCount: this.outlierCountQty,
        });
      }
      const u = this.unitBounds;
      if (u && u.q1 != null && u.q3 != null) {
        blocks.push({
          key: 'unit', title: 'Harga Seunit (RM Negeri ÷ Kuantiti)', isMoney: true, color: '#7E57C2',
          n,
          min: u.min, q1: u.q1, median: u.median, q3: u.q3, max: u.max, iqr: u.iqr,
          lower: u.lower, upper: u.upper,
          outlierCount: null,
        });
      }
      // Attach the display-clamped lower fence to every block in one place.
      blocks.forEach(b => {
        b.lowerClamped = Math.max(0, b.lower);
        b.lowerNegative = b.lower < 0;
      });
      return blocks.length ? blocks : null;
    },
    anomalyNote() {
      const s = this.drillStatsData;
      if (!s) return null;
      if (s.outlierCount >= 2) {
        return { type: 'error', message: `${s.outlierCount} outlier harga: ${s.outlierValues.map(v => this.fmt(v)).join(', ')} — di luar julat ${this.fmt(s.wL)}–${this.fmt(s.wH)}. Sila siasatan lanjut.` };
      } else if (s.outlierCount === 1) {
        return { type: 'warning', message: `1 nilai luar jangka: ${this.fmt(s.outlierValues[0])} — melebihi had ${this.fmt(s.wH)}. Disyorkan semak.` };
      }
      return { type: 'success', message: 'Semua harga dalam julat normal bagi rekod terpilih.' };
    },
  },

  watch: {
    // Vuetify updates sortBy and sortDesc in two separate ticks when a header is
    // clicked: it pushes the column into sortBy first, then sets sortDesc on the
    // next tick. A naive deep watcher fires on the first (incomplete) update and
    // fetches with a stale sort direction — so the first click appears to do
    // nothing and a second click is needed. Coalesce the bursts into one fetch
    // on the next microtask so both arrays are settled before we read them.
    mainOptions: {
      handler() {
        clearTimeout(this.mainOptionsTimer);
        this.mainOptionsTimer = setTimeout(() => this.fetchMainData(), 0);
      },
      deep: true,
    },
    drillOptions: {
      handler() {
        clearTimeout(this.drillOptionsTimer);
        this.drillOptionsTimer = setTimeout(() => {
          if (this.selectedKod) this.fetchDrillData();
        }, 0);
      },
      deep: true,
    },
    // Pusingan range → rebuild filters.pusingan and refetch. Raising From past To
    // drags To along so the range stays valid.
    pusinganFrom(v) {
      if (v != null && this.pusinganTo != null && this.pusinganTo < v) this.pusinganTo = v;
      this.syncPusinganRange();
    },
    pusinganTo() {
      this.syncPusinganRange();
    },
  },

  async mounted() {
    // if Konsensus is disabled, never sit on its (now-missing) tab
    if (!this.showKonsensus) this.activeTab = 0;
    try {
      this.filterOptions = await getFilterOptions();
      // Negeri-locked roles (PP/PO/FE/DE): the backend already returns ONLY their own
      // negeri in negeriList, so pin the selector to it and disable the dropdown.
      const lock = negeriLock(this.$store, 'julatHarga');
      if (lock.locked) {
        this.negeriLocked = true;
        this.filters.negeri = lock.kodneg;
      }
      // Only show ACTIVE pusingan (status == 1) in the range filter — same rule as
      // kadarrespon / the Wajaran view. getFilterOptions returns every distinct
      // jr2.P (no status), so we override pusinganList with the active set here.
      this.filterOptions.pusinganList = await this.loadActivePusingan(this.filterOptions.pusinganList);
      // default: full pusingan range selected. Set filters.pusingan directly too so
      // the first paint isn't empty (pusinganParam() treats "all" as no filter), then
      // default the From–To bounds to first–last available.
      this.filters.pusingan = [...(this.filterOptions.pusinganList || [])];
      this.setPusinganFullRange();
    } catch (e) {
      console.error('getFilterOptions failed:', e);
    }
    // Daerah list for every negeri, fetched once. A failure here only costs the
    // daerah filter — the rest of the page must still load.
    try {
      const res = await lookupSvc.getDPAll();
      this.dpAll = (res && res.data) || [];
    } catch (e) {
      console.error('getDPAll failed:', e);
    }
    document.addEventListener('fullscreenchange', this.onFullscreenChange);
    // the v-data-table's :options.sync emits an initial update that triggers the
    // first fetchMainData via the mainOptions watcher
  },

  methods: {
    // ── Main table data ──────────────────────────────────────────────────────
    async fetchMainData() {
      const seq = ++this.mainReqSeq;
      this.mainLoading = true;
      try {
        const { page, itemsPerPage, sortBy, sortDesc } = this.mainOptions;
        const result = await fetchMainTable({
          page, itemsPerPage, sortBy, sortDesc,
          negeri: this.filters.negeri,
          pusingan: this.pusinganParam(),
          dp: this.daerahParam,
          search: this.filters.search,
        });
        // a newer request started while this one was in flight → discard this
        // (stale) response so it can't overwrite the freshly-sorted rows
        if (seq !== this.mainReqSeq) return;
        this.mainItems = result.items || [];
        this.mainTotal = result.total || 0;
        this.summary = {
          anomCount: result.anomCount || 0,
          warnCount: result.warnCount || 0,
          totalRecords: result.totalRecords || 0,
        };
      } catch (e) {
        if (seq !== this.mainReqSeq) return;
        console.error('fetchMainData failed:', e);
        this.snackbar = { show: true, message: 'Gagal memuatkan senarai item', color: 'error', timeout: 3000 };
      } finally {
        // only the latest request controls the loading spinner
        if (seq === this.mainReqSeq) this.mainLoading = false;
      }
    },

    // ── Drill table data ─────────────────────────────────────────────────────
    async fetchDrillData() {
      if (!this.selectedKod) return;
      const seq = ++this.drillReqSeq;
      this.drillLoading = true;
      try {
        const { page, itemsPerPage, sortBy, sortDesc } = this.drillOptions;
        const result = await fetchDrillTable({
          kod: this.selectedKod,
          page, itemsPerPage, sortBy, sortDesc,
          // hid is NOT sent here — it only pins/highlights, never filters the list
          outlierType: this.outlierTypeParam(),
          minH: this.drillFilters.minH,
          maxH: this.drillFilters.maxH,
          minQ: this.drillFilters.minQ,
          maxQ: this.drillFilters.maxQ,
          negeri: this.filters.negeri,
          pusingan: this.pusinganParam(),
          dp: this.daerahParam,
        });
        // discard a stale response superseded by a newer drill request
        if (seq !== this.drillReqSeq) return;
        this.drillItems = result.items || [];
        this.drillTotal = result.total || 0;
        this.drillStatsData = result.stats;
        this.drillNama = result.nama || '';
        this.drillUnit = result.unit || '';
      } catch (e) {
        if (seq !== this.drillReqSeq) return;
        console.error('fetchDrillData failed:', e);
        this.snackbar = { show: true, message: 'Gagal memuatkan butiran sebutan', color: 'error', timeout: 3000 };
      } finally {
        if (seq === this.drillReqSeq) this.drillLoading = false;
      }
    },

    // ── Export Excel ──────────────────────────────────────────────────────────
    async exportMainTable() {
      const items = await fetchMainTableExport({
        negeri: this.filters.negeri,
        pusingan: this.pusinganParam(),
        dp: this.daerahParam,
        search: this.filters.search,
      });
      return items;
    },

    // Streams the CSV from the server and saves it. Can run for a while on a large
    // item (~500k rows), hence the button spinner.
    async exportDrillTable() {
      this.drillExporting = true;
      this.stampNow();
      let url = null;
      try {
        const blob = await fetchDrillTableExport({
          kod: this.selectedKod,
          hid: this.drillFilters.hid,
          outlierType: this.outlierTypeParam(),
          minH: this.drillFilters.minH,
          maxH: this.drillFilters.maxH,
          minQ: this.drillFilters.minQ,
          maxQ: this.drillFilters.maxQ,
          negeri: this.filters.negeri,
          pusingan: this.pusinganParam(),
          dp: this.daerahParam,
        });
        url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = this.drillExportName;
        document.body.appendChild(a);
        a.click();
        a.remove();
      } catch (e) {
        console.error('exportDrillTable failed:', e);
        this.snackbar = { show: true, message: 'Gagal memuat turun CSV butiran sebutan', color: 'error', timeout: 4000 };
      } finally {
        // revoke only after the browser has had a tick to start the download,
        // otherwise a large file can be cancelled mid-save
        if (url) setTimeout(() => window.URL.revokeObjectURL(url), 10000);
        this.drillExporting = false;
      }
    },

    // Build the pusingan request param from the multi-select:
    //   all selected  → '' (no filter, all data)
    //   some selected → CSV of codes (whereIn)
    //   none selected → '__NONE__' marker (backend returns empty)
    pusinganParam() {
      const all = (this.filterOptions.pusinganList || []).length;
      const n = this.filters.pusingan.length;
      // Options not loaded yet → don't send the "none" marker (that would wrongly
      // empty the table on first paint, before the default-all is applied).
      if (all === 0) return '';
      if (n === 0) return '__NONE__';
      if (n === all) return '';
      return this.filters.pusingan.join(',');
    },

    // ── Filters ──────────────────────────────────────────────────────────────
    onFilterChange() {
      this.mainOptions.page = 1;
      this.closeDrill();
      this.fetchMainData();
    },

    // DP codes restart at 01 in every negeri, so a negeri change invalidates the
    // daerah selection. This MUST clear before onFilterChange fetches — a watcher
    // would not, because Vue queues watchers asynchronously and the fetch would
    // still carry the previous negeri's DP codes.
    onNegeriChange() {
      this.filters.daerah = [];
      this.onFilterChange();
    },

    // live search bar — debounce so the table refetches a beat after typing stops
    onSearchInput() {
      clearTimeout(this.searchDebounce);
      this.searchDebounce = setTimeout(() => this.onFilterChange(), 300);
    },

    // Rebuild filters.pusingan from the From–To range (inclusive), preserving the
    // raw list values, then refetch. Guards against the options not being loaded
    // or the bounds being unset (avoids wrongly emptying the table on first paint).
    syncPusinganRange() {
      if (!this.pusinganNums.length || this.pusinganFrom == null || this.pusinganTo == null) return;
      const lo = Math.min(this.pusinganFrom, this.pusinganTo);
      const hi = Math.max(this.pusinganFrom, this.pusinganTo);
      this.filters.pusingan = this.pusinganNums
        .filter(o => o.num >= lo && o.num <= hi)
        .map(o => o.raw);
      this.onFilterChange();
    },

    // Default the range to all available pusingan (first–last).
    setPusinganFullRange() {
      const nums = this.pusinganNums;
      if (!nums.length) return;
      this.pusinganFrom = nums[0].num;
      this.pusinganTo = nums[nums.length - 1].num;
    },

    // Restrict the pusingan list to ACTIVE ones (status == 1) via getAllPusingan()
    // — same rule as kadarrespon / the Wajaran view. We keep only the codes from
    // `fallbackList` (the real jr2.P values) whose pusingan number is active, so the
    // values still match what the backend expects. On any failure we return the
    // fallback unchanged (so a service hiccup never empties the filter).
    async loadActivePusingan(fallbackList) {
      const fallback = fallbackList || [];
      try {
        const res = await pusinganSvc.getAllPusingan();
        const rows = (res && res.data && res.data.data) || [];
        const activeNums = new Set(
          rows
            .filter(r => r.status == "1" || r.status == 1)
            .map(r => parseInt(r.pusingan, 10))
            .filter(n => !isNaN(n))
        );
        if (!activeNums.size) return fallback;
        const filtered = fallback.filter(p => activeNums.has(parseInt(p, 10)));
        return filtered.length ? filtered : fallback;
      } catch (e) {
        console.error('loadActivePusingan failed:', e);
        return fallback;
      }
    },

    resetFilters() {
      this.filters = {
        // Locked roles (PP/PO/FE/DE) stay pinned to their own negeri — clearing it
        // to null means "Semua", which blanks the select and makes the export
        // filename claim negeri-semua.
        negeri: this.negeriLocked ? this.filters.negeri : null,
        pusingan: [...(this.filterOptions.pusinganList || [])],
        daerah: [],
        search: '',
      };
      this.setPusinganFullRange();
      this.onFilterChange();
    },

    onDrillFilterChange() {
      clearTimeout(this.drillFilterTimer);
      this.drillFilterTimer = setTimeout(() => {
        this.drillOptions.page = 1;
        this.fetchDrillData();
      }, 300);
    },

    // HID field: pin + highlight the matching record (does NOT filter the list)
    onHidInput() {
      clearTimeout(this.drillFilterTimer);
      this.drillFilterTimer = setTimeout(() => this.fetchPinned(), 300);
    },

    // pin ALL records sharing the targeted HID on top (a HID may have several records)
    async fetchPinned() {
      const hid = this.drillFilters.hid;
      if (!hid || !this.selectedKod) { this.pinnedHid = null; this.pinnedRecords = []; return; }

      // 1) prefer the full records we already loaded (carry outlier flags)
      let recs = this.allDrillRecords.filter(r => String(r.hid) === String(hid));

      // 2) fall back to a direct fetch (all matching rows) if not in memory
      if (!recs.length) {
        try {
          const result = await fetchDrillTable({
            kod: this.selectedKod, page: 1, itemsPerPage: -1, hid,
            negeri: this.filters.negeri, pusingan: this.pusinganParam(), dp: this.daerahParam,
          });
          recs = result.items || [];
        } catch (e) {
          console.error('fetchPinned failed:', e);
          recs = [];
        }
      }

      if (!recs.length) {
        this.snackbar = { show: true, message: `HID ${hid} tidak dijumpai`, color: 'warning', timeout: 2500 };
      }
      this.pinnedHid = hid;
      this.applyPinned(recs);
    },

    // set the pinned records + (re)compute outlier flags from the chart bounds so the
    // pinned rows' RM Negeri (red) / Kuantiti (orange) / Flag styling matches the chart
    applyPinned(recs) {
      this.pinnedRecords = (recs || []).map(r => {
        const rec = { ...r };
        if (this.hargaBounds) {
          rec.isHargaOutlier = rec.rmNegeri < this.hargaBounds.lower || rec.rmNegeri > this.hargaBounds.upper;
        }
        if (this.qtyBounds) {
          rec.isQtyOutlier = rec.kuantiti < this.qtyBounds.lower || rec.kuantiti > this.qtyBounds.upper;
        }
        if (this.unitBounds) {
          const u = this.unitPrice(rec);
          rec.isUnitOutlier = u != null && (u < this.unitBounds.lower || u > this.unitBounds.upper);
        }
        return rec;
      });
    },

    // Only the Harga Seunit flag tints the whole row. A record can sit outside the
    // absolute RM or Kuantiti fences and still be a perfectly ordinary purchase
    // (RM 119.70 for 30 kg = RM 3.99/kg) — those keep their coloured cell as a
    // factual note but must not read as "suspect". Pinning wins over both.
    drillRowClass(item) {
      if (this.pinnedHid && String(item.hid) === String(this.pinnedHid)) return 'pinned-row';
      return item.isUnitOutlier ? 'unit-outlier-row' : '';
    },

    resetDrillFilters() {
      this.drillFilters = { hid: null, outlierType: 'Semua', minH: null, maxH: null, minQ: null, maxQ: null };
      this.pinnedHid = null;
      this.pinnedRecords = [];
      this.drillOptions.page = 1;
      this.fetchDrillData();
    },

    // surface consensus-tab fetch errors via the page snackbar
    onConsensusError(msg) {
      this.snackbar = { show: true, message: msg || 'Gagal mengira konsensus', color: 'error', timeout: 3000 };
    },

    // ── Select item → show charts + drill ────────────────────────────────────
    async selectItem(row) {
      this.selectedKod = row.kod;
      this.selectedItem = row;
      this.drillFilters = { hid: null, outlierType: 'Semua', minH: null, maxH: null, minQ: null, maxQ: null };
      this.pinnedHid = null;
      this.pinnedRecords = [];
      this.drillOptions = { page: 1, itemsPerPage: 10, sortBy: [], sortDesc: [] };
      this.detailLoading = true;

      // scroll to the "Item Dipilih" card once it renders (it shows immediately,
      // before the charts/drill data finish loading)
      this.$nextTick(() => {
        const el = this.$refs.selectedCard && this.$refs.selectedCard.$el;
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });

      try {
        // wait for BOTH the detail table and the chart dataset before revealing
        const [, chartResult] = await Promise.all([
          this.fetchDrillData(),
          fetchDrillTable({
            kod: row.kod, page: 1, itemsPerPage: -1,
            negeri: this.filters.negeri, pusingan: this.pusinganParam(), dp: this.daerahParam,
          }),
        ]);
        // keep full records (with outlier flags) + bounds so a pinned record keeps its styling.
        // Prefer the server's FULL-dataset IQR fences/quantiles (authoritative) over
        // recomputing from the 500-row chart sample — the sample could disagree and
        // mis-flag borderline outliers.
        this.allDrillRecords = chartResult.items || [];
        const st = chartResult.stats;
        this.hargaBounds = st
          ? { min: st.minH, q1: st.q1H, median: st.medianH, q3: st.q3H, max: st.maxH,
              iqr: st.iqrH, lower: st.hargaLower, upper: st.hargaUpper }
          : calcStats(chartResult.allHarga || []);
        this.qtyBounds = st
          ? { min: st.minQ, q1: st.q1Q, median: st.medianQ, q3: st.q3Q, max: st.maxQ,
              iqr: st.iqrQ, lower: st.qtyLower, upper: st.qtyUpper }
          : calcStats(chartResult.allQty || []);
        // No calcStats fallback: the server sends the seunit quantiles over the FULL
        // dataset, and the 500-row sample can't beat that.
        this.unitBounds = st
          ? { min: st.minU, q1: st.q1U, median: st.medianU, q3: st.q3U, max: st.maxU,
              iqr: st.iqrU, lower: st.unitLower, upper: st.unitUpper }
          : calcStats(chartResult.allUnit || []);
        // cache datasets so the Mod / Skala-Y toggles can redraw without refetch
        this.chartData = {
          harga: { arr: chartResult.allHarga, hids: chartResult.allHids },
          qty: { arr: chartResult.allQty, hids: chartResult.allHids },
          unit: { arr: chartResult.allUnit, hids: chartResult.allHids },
        };
        // Load the FULL outlier sets BEFORE revealing the charts, so they render
        // once with complete data instead of drawing the 500-sample then visibly
        // re-rendering when the outliers arrive. draw:false — we draw below, after
        // the canvases mount (they are inside v-if="!detailLoading").
        await this.fetchOutlierCounts({ draw: false });
        this.detailLoading = false;
        this.$nextTick(() => {
          this.drawChart('harga', chartResult.allHarga, chartResult.allHids);
          this.drawChart('qty', chartResult.allQty, chartResult.allHids);
          this.drawChart('unit', chartResult.allUnit, chartResult.allHids);
        });
      } catch (e) {
        console.error('detail load failed:', e);
        this.detailLoading = false;
        this.snackbar = { show: true, message: 'Gagal memuatkan data terperinci', color: 'error', timeout: 3000 };
      }
    },

    // ALL outlier records straight from the server — the SAME set you get by setting
    // Penapis Outlier = Harga / Kuantiti — so every outlier shows on the chart and the
    // counts match the filtered table. Charts are redrawn once the full set arrives.
    // Loads the full harga/kuantiti outlier sets + true counts. By default it also
    // redraws the charts; pass { draw: false } during the initial load so the
    // caller can reveal the canvases first, then draw once with complete data.
    async fetchOutlierCounts({ draw = true } = {}) {
      if (!this.selectedKod) return;
      const base = {
        kod: this.selectedKod,
        negeri: this.filters.negeri, pusingan: this.pusinganParam(), dp: this.daerahParam,
      };
      try {
        const [all, h, q, u] = await Promise.all([
          fetchDrillTable({ ...base, page: 1, itemsPerPage: 1 }),
          fetchDrillTable({ ...base, page: 1, itemsPerPage: -1, outlierType: 'Harga' }),
          fetchDrillTable({ ...base, page: 1, itemsPerPage: -1, outlierType: 'Kuantiti' }),
          fetchDrillTable({ ...base, page: 1, itemsPerPage: -1, outlierType: 'Unit' }),
        ]);
        this.totalAll = all.total || 0;
        const hAll = h.items || [];
        const qAll = q.items || [];
        const uAll = u.items || [];
        // true totals (badge / dialog) are the full counts — kept before capping
        this.outlierCountHarga = h.total || hAll.length;
        this.outlierCountQty = q.total || qAll.length;
        this.outlierCountUnit = u.total || uAll.length;
        // cap the PLOTTED set so a high-volume item (up to ~48k outliers) doesn't
        // freeze the canvas. Extremes are always kept; the middle is sampled.
        this.outlierRecsHarga = this.capOutliers(hAll, 'rmNegeri');
        this.outlierRecsQty = this.capOutliers(qAll, 'kuantiti');
        this.outlierRecsUnit = this.capOutliers(uAll, 'unitPrice');
        if (draw) {
          this.redrawChart('harga');
          this.redrawChart('qty');
          this.redrawChart('unit');
        }
      } catch (e) {
        console.error('fetchOutlierCounts failed:', e);
      }
    },

    // Downsample outlier records for plotting: keep the most extreme low/high
    // values (the real anomalies) and evenly sample the middle, so the canvas
    // never has to draw more than MAX_OUTLIER_POINTS. Returns the original array
    // unchanged when it already fits. `key` is the value field ('rmNegeri'/'kuantiti').
    capOutliers(recs, key) {
      const MAX = 2000;
      if (!Array.isArray(recs) || recs.length <= MAX) return recs || [];
      // sort a copy ascending by value so extremes sit at both ends
      const sorted = [...recs].sort((a, b) => (Number(a[key]) || 0) - (Number(b[key]) || 0));
      const n = sorted.length;
      const KEEP_EXTREMES = 150;                 // always keep this many at each tail
      const out = [];
      const taken = new Set();
      const push = i => { if (i >= 0 && i < n && !taken.has(i)) { taken.add(i); out.push(sorted[i]); } };
      for (let i = 0; i < KEEP_EXTREMES; i++) { push(i); push(n - 1 - i); }
      // even-sample the middle for the remaining budget
      const budget = MAX - out.length;
      const lo = KEEP_EXTREMES, hi = n - KEEP_EXTREMES;
      if (hi > lo && budget > 0) {
        const step = (hi - lo) / budget;
        for (let i = lo; i < hi; i += step) push(Math.floor(i));
      }
      return out;
    },

    closeDrill() {
      this.selectedKod = null;
      this.selectedItem = null;
      this.detailLoading = false;
      this.totalAll = 0;
      this.outlierCountHarga = 0;
      this.outlierCountQty = 0;
      this.outlierCountUnit = 0;
      this.outlierRecsHarga = [];
      this.outlierRecsQty = [];
      this.outlierRecsUnit = [];
      this.drillItems = [];
      this.pinnedHid = null;
      this.pinnedRecords = [];
      this.drillTotal = 0;
      this.drillStatsData = null;
      this.unitBounds = null;
      this.isFullscreenHarga = false;
      this.isFullscreenQty = false;
      this.isFullscreenUnit = false;
      this.chartData = { harga: null, qty: null, unit: null };
      ['chartH', 'chartQ', 'chartU'].forEach(k => {
        if (this[k]) { this[k].destroy(); this[k] = null; }
      });
    },

    // ── Fullscreen ───────────────────────────────────────────────────────────
    // The old implementation was a CSS overlay (position:fixed + z-index 9999).
    // That can never work here: maintemplate's `.v-main { z-index: 1 }` opens a
    // stacking context, so the card is flattened into layer 1 and painted BELOW
    // the app bar (5) and nav drawer (6) — the exit button ends up unreachable.
    // The native Fullscreen API renders in the browser's top layer, which no
    // stacking context can trap, and gives us ESC-to-close for free.
    toggleFullscreen(mode) {
      if (document.fullscreenElement) { document.exitFullscreen(); return; }
      const card = this.$refs[this.chartCfg(mode).card];
      const el = card && card.$el;
      if (el && el.requestFullscreen) el.requestFullscreen();
    },

    // Fires for the icon button AND for ESC / the browser's own exit, so the icon
    // state can never drift out of sync with the actual fullscreen element.
    onFullscreenChange() {
      const fs = document.fullscreenElement;
      const isCard = ref => !!fs && !!this.$refs[ref] && fs === this.$refs[ref].$el;
      this.isFullscreenHarga = isCard('cardHarga');
      this.isFullscreenQty = isCard('cardQty');
      this.isFullscreenUnit = isCard('cardUnit');
      // Chart.js only watches window resize; entering/leaving fullscreen changes
      // the container without one, so resize explicitly.
      this.$nextTick(() => {
        ['chartH', 'chartQ', 'chartU'].forEach(k => { if (this[k]) this[k].resize(); });
      });
    },

    // Redraw a chart from cached data after a Mod / Skala-Y toggle
    redrawChart(mode) {
      const d = this.chartData[mode];
      if (d && d.arr) this.$nextTick(() => this.drawChart(mode, d.arr, d.hids));
    },

    // Zoom in (factor > 1) / out (factor < 1) around the current view centre
    zoomChart(mode, factor) {
      const ch = this[this.chartCfg(mode).inst];
      if (!ch) return;
      const apply = (scale, axisOpt) => {
        if (!scale || !axisOpt) return;
        const min = scale.min, max = scale.max;
        if (min == null || max == null) return;
        const centre = (min + max) / 2;
        const half = (max - min) / 2 / factor;
        axisOpt.ticks = axisOpt.ticks || {};
        axisOpt.ticks.min = centre - half;
        axisOpt.ticks.max = centre + half;
      };
      apply(ch.scales['x-axis-1'], ch.options.scales.xAxes[0]);
      apply(ch.scales['y-axis-1'], ch.options.scales.yAxes[0]);
      ch.update();
    },

    // Restore the chart to its original (un-zoomed) view
    resetZoom(mode) {
      const ch = this[this.chartCfg(mode).inst];
      if (!ch) return;
      ['xAxes', 'yAxes'].forEach(a => {
        const t = ch.options.scales[a] && ch.options.scales[a][0] && ch.options.scales[a][0].ticks;
        if (t) { delete t.min; delete t.max; }
      });
      if (ch.resetZoom) ch.resetZoom(); else ch.update();
    },

    mainRowClass(item) {
      return this.selectedKod === item.kod ? 'blue lighten-5' : '';
    },

    // ── Helpers ──────────────────────────────────────────────────────────────
    statusColor(s) {
      return s === 'a' ? 'red lighten-4' : s === 'w' ? 'orange lighten-4' : 'green lighten-4';
    },
    statusTextColor(s) {
      return s === 'a' ? 'red' : s === 'w' ? 'orange darken-2' : 'green';
    },
    statusLabel(s) {
      return s === 'a' ? 'Anomali' : s === 'w' ? 'Semak' : 'Normal';
    },
    // Harga seunit = RM Negeri ÷ Kuantiti. Prefer the server-computed value
    // (so it matches the server-side sort) and fall back to dividing locally.
    // Returns null when kuantiti is 0/missing so fmt() shows RM 0.00 rather than ∞.
    unitPrice(r) {
      if (r && r.unitPrice != null && !isNaN(r.unitPrice)) return Number(r.unitPrice);
      const q = Number(r && r.kuantiti);
      const p = Number(r && r.rmNegeri);
      if (!q || isNaN(q) || isNaN(p)) return null;
      return p / q;
    },
    // 'Semua' (or cleared) = no filter. Kept as a method so the three call sites
    // can't drift apart when a new option is added.
    outlierTypeParam() {
      const t = this.drillFilters.outlierType;
      if (t === 'Outlier sahaja') return 'Ada';
      if (t === 'Outlier Harga Seunit') return 'Unit';
      return '';
    },
    getFlag(r) {
      // Seunit wins the label: it is the only flag that means "suspect".
      if (r.isUnitOutlier) return 'Seunit';
      if (r.isHargaOutlier && r.isQtyOutlier) return 'Harga+Qty';
      if (r.isHargaOutlier) return 'Harga';
      if (r.isQtyOutlier) return 'Kuantiti';
      return '';
    },
    fmt(n) { 
      if (n == null || isNaN(n)) return 'RM 0.00';
      return 'RM ' + Number(n).toLocaleString('ms-MY', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); 
    },
    fmtN(n) {
      if (n == null || isNaN(n)) return '0';
      return Number(n).toLocaleString();
    },
    // Filesystem-safe filename fragment: lowercase, non-alphanumerics → '-', capped.
    slug(s) {
      return String(s == null ? '' : s)
        .trim().toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')
        .slice(0, 40) || 'x';
    },
    // compact "YYYYMMDD-HHMM" stamp for filenames
    makeStamp() {
      const d = new Date();
      const p = n => String(n).padStart(2, '0');
      return `${d.getFullYear()}${p(d.getMonth() + 1)}${p(d.getDate())}-${p(d.getHours())}${p(d.getMinutes())}`;
    },
    // download-excel :before-generate hook — refresh the timestamp so the filename
    // reflects the moment of export (computeds cache, so we update reactive state)
    stampNow() {
      this.exportStampVal = this.makeStamp();
    },
    // Wrap the current search term in <mark> within a cell value. Always HTML-escapes
    // the source text first (the result is rendered with v-html), so it is XSS-safe.
    highlight(text) {
      const str = text == null ? '' : String(text);
      const esc = s => s.replace(/[&<>"']/g, c => (
        { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]
      ));
      const term = (this.filters.search || '').trim();
      if (!term) return esc(str);
      // escape regex special chars in the term, match case-insensitively
      const safe = term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const re = new RegExp('(' + safe + ')', 'gi');
      // escape the text, then highlight (the term has no HTML special chars left
      // that would break, since we split on the raw value and escape each part)
      return str
        .split(re)
        .map((part, i) => (i % 2 === 1 ? '<mark class="kh">' + esc(part) + '</mark>' : esc(part)))
        .join('');
    },
    fmtBy(isMoney, v) {
      return isMoney ? this.fmt(v) : this.fmtN(v);
    },

    // "< X atau > Y" — the IQR fence (lower / upper). The lower fence is clamped to 0
    // for display for the same reason as the formula dialog: Q1 − 1.5 × IQR can go
    // negative, and a negative ringgit/kuantiti is meaningless. Display only — the
    // flags themselves still use the raw fence (identical result, since no record
    // has a negative value).
    fenceText(fence, fmtFn) {
      if (!fence) return '';
      return '< ' + fmtFn(Math.max(0, fence.lower)) + ' atau > ' + fmtFn(fence.upper);
    },

    // Everything that differs between the three charts, in one place. Added when
    // the Harga Seunit chart arrived — three-way ternaries on an `isH` boolean
    // would have been unreadable.
    chartCfg(mode) {
      if (mode === 'qty') {
        return {
          inst: 'chartQ', canvas: 'chartQty', card: 'cardQty', valKey: 'kuantiti',
          fence: this.qtyFence, bounds: this.qtyBounds, recs: this.outlierRecsQty,
          money: false, axis: 'Kuantiti',
        };
      }
      if (mode === 'unit') {
        return {
          inst: 'chartU', canvas: 'chartUnit', card: 'cardUnit', valKey: 'unitPrice',
          fence: this.unitFence, bounds: this.unitBounds, recs: this.outlierRecsUnit,
          money: true, axis: 'Harga Seunit (RM)', outColor: '#7E57C2',
        };
      }
      return {
        inst: 'chartH', canvas: 'chartHarga', card: 'cardHarga', valKey: 'rmNegeri',
        fence: this.hargaFence, bounds: this.hargaBounds, recs: this.outlierRecsHarga,
        money: true, axis: 'Harga (RM)',
      };
    },

    // ── Charts (Chart.js v2 scatter with box plot overlay) ───────────────────
    drawChart(mode, arr, hids) {
      if (!arr || !arr.length) return;
      const cfg = this.chartCfg(mode);
      const dataMode = this.chartMode[mode]; // 'sample' | 'outlier'
      const st = calcStats(arr); // sample-based fallback only
      // Use the SAME server-computed fence/median as the legend & "Cara pengiraan
      // outlier" dialog (full dataset for all three metrics) so the chart lines
      // and outlier colouring match the table exactly.
      const fence = cfg.fence;
      const lowerB = fence && fence.lower != null ? fence.lower : st.lower;
      const upperB = fence && fence.upper != null ? fence.upper : st.upper;
      // median line from the authoritative server bounds (full dataset); fall back
      // to the sample median only if the server bounds haven't loaded.
      const bounds = cfg.bounds;
      const medianB = (bounds && bounds.median != null) ? bounds.median : st.median;
      // ── Outliers: plot EVERY outlier record fetched from the server (the full set,
      //    matching the table) — never sampled. Fall back to fence-based detection on
      //    the chart array only if the server records haven't loaded yet. ──
      const valKey = cfg.valKey;
      const outRecs = cfg.recs;
      let outlierPts;
      if (outRecs && outRecs.length) {
        outlierPts = outRecs
          .map(r => ({ y: Number(r[valKey]), hid: r.hid }))
          .filter(p => !isNaN(p.y));
      } else {
        outlierPts = arr
          .map((v, i) => ({ y: v, hid: hids ? hids[i] : ('H' + (i + 1)) }))
          .filter(p => p.y < lowerB || p.y > upperB);
      }
      const outHidSet = new Set(outlierPts.map(p => String(p.hid)));

      // ── Normal cloud = everything that is NOT an outlier, thinned to 500 samples
      //    (hidden entirely in "Outlier sahaja" mode). ──
      const SAMPLE = 500;
      let normalData = [];
      if (dataMode !== 'outlier') {
        const normals = arr
          .map((v, i) => ({ y: v, hid: hids ? hids[i] : ('H' + (i + 1)) }))
          .filter(p => !outHidSet.has(String(p.hid)));
        if (normals.length > SAMPLE) {
          const step = normals.length / SAMPLE;
          for (let i = 0; i < normals.length; i += step) normalData.push(normals[Math.floor(i)]);
        } else {
          normalData = normals;
        }
      }

      // spread points along x — shuffle so normals & outliers intermix (nicer spread)
      const tickPts = normalData.concat(outlierPts);
      for (let i = tickPts.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        const tmp = tickPts[i]; tickPts[i] = tickPts[j]; tickPts[j] = tmp;
      }
      tickPts.forEach((p, i) => { p.x = i + 1; });
      const outlierData = outlierPts;

      // purple on the seunit chart so its outliers read as the same "suspect" signal
      // as the tinted rows in the table; orange elsewhere.
      const outColor = cfg.outColor || '#F57C00';
      const normalColor = 'rgba(14,165,164,0.35)';
      const medColor = '#2563eb';   // median (blue)
      const upperColor = '#DC2626'; // pagar atas (red)
      const lowerColor = '#16A34A'; // pagar bawah (green)

      // labelled reference lines drawn across the plot
      const fmtVal = v => cfg.money ? this.fmt(v) : this.fmtN(v);
      const refLines = [
        { val: upperB, color: upperColor, label: 'Had Atas: ' + fmtVal(upperB), dash: [6, 3] },
        { val: medianB, color: medColor, label: 'Median: ' + fmtVal(medianB), dash: [] },
        { val: lowerB, color: lowerColor, label: 'Had Bawah: ' + fmtVal(lowerB), dash: [6, 3] },
      ];

      if (this[cfg.inst]) { this[cfg.inst].destroy(); this[cfg.inst] = null; }

      const canvas = this.$refs[cfg.canvas];
      if (!canvas) return;
      const ctx = canvas.getContext('2d');

      const boxPlugin = {
        id: 'box_' + mode,
        afterDraw(chart) {
          const c = chart.ctx;
          const xScale = chart.scales['x-axis-1'];
          const yScale = chart.scales['y-axis-1'];
          if (!xScale || !yScale) return;
          const left = xScale.left, right = xScale.right;

          c.save();
          // px: dilukis ke canvas, tiada pewarisan CSS. 13px = --fs-xs.
          c.font = '600 13px sans-serif';
          c.textBaseline = 'bottom';
          c.textAlign = 'left';
          refLines.forEach(ln => {
            if (ln.val == null || isNaN(ln.val)) return;
            if (ln.val < yScale.min || ln.val > yScale.max) return; // outside visible range
            const y = yScale.getPixelForValue(ln.val);
            c.strokeStyle = ln.color;
            c.lineWidth = 1.5;
            c.setLineDash(ln.dash);
            c.beginPath(); c.moveTo(left, y); c.lineTo(right, y); c.stroke();
            c.setLineDash([]);
            c.fillStyle = ln.color;
            c.fillText(ln.label, left + 6, y - 3);
          });
          c.restore();
        }
      };

      const ch = new Chart(ctx, {
        type: 'scatter',
        data: {
          datasets: [
            { label: 'Data normal', data: normalData, backgroundColor: normalColor, pointRadius: 3, pointHoverRadius: 6 },
            { label: 'Outlier', data: outlierData, backgroundColor: outColor, pointRadius: 5, pointHoverRadius: 8, pointStyle: 'triangle' },
            { label: 'Had Atas', data: [], backgroundColor: upperColor, borderColor: upperColor, pointStyle: 'line' },
            { label: 'Median', data: [], backgroundColor: medColor, borderColor: medColor, pointStyle: 'line' },
            { label: 'Had Bawah', data: [], backgroundColor: lowerColor, borderColor: lowerColor, pointStyle: 'line' }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          // click a point → pin + highlight its HID in the butiran table below
          onClick: (evt, active) => {
            const els = (active && active.length) ? active : ch.getElementAtEvent(evt);
            if (!els || !els.length) return;
            const el = els[0];
            const pt = ch.data.datasets[el._datasetIndex].data[el._index];
            if (!pt || pt.hid == null) return;
            this.drillFilters.hid = String(pt.hid);
            this.fetchPinned();
            // scroll the butiran table into view so the pinned row is visible
            this.$nextTick(() => {
              const el = this.$refs.drillCard && this.$refs.drillCard.$el;
              if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
            });
          },
          plugins: {
            zoom: {
              pan: { enabled: true, mode: 'xy' },                    // drag to pan
              // Starts DISABLED so a plain wheel scrolls the page. The capture
              // listener below flips this on only while Ctrl is held — see
              // attachCtrlWheelZoom. speed is per wheel tick: 0.1 zoomed so fast
              // that a single flick overshot the data, 0.03 is a gradual step.
              zoom: { enabled: false, mode: 'xy', speed: 0.03 },
            },
          },
          legend: {
            display: true,
            position: 'top',
            align: 'end',
            labels: {
              boxWidth: 12,
              usePointStyle: true,
              // hide the "Data normal" entry from the legend (dataset still drawn)
              filter: item => item.text !== 'Data normal',
            }
          },
          tooltips: {
            callbacks: {
              title: (tooltipItems, data) => {
                const dsIndex = tooltipItems[0].datasetIndex;
                const ptIndex = tooltipItems[0].index;
                const pt = data.datasets[dsIndex].data[ptIndex];
                return pt && pt.hid ? pt.hid : 'Rekod ke-' + tooltipItems[0].xLabel;
              },
              label: (item, data) => {
                const pt = data.datasets[item.datasetIndex].data[item.index];
                const val = fmtVal(item.yLabel);
                const isOut = pt && outHidSet.has(String(pt.hid));
                return val + (isOut ? ' ⚠ Outlier' : '');
              }
            }
          },
          scales: {
            xAxes: [{
              // x is just an arbitrary scatter spread (point index) with no real
              // meaning, so the whole axis is suppressed: no labels, no tick marks
              // and no vertical gridlines. This keeps it visually static while the
              // zoom plugin pans/zooms (it otherwise regenerates ticks + gridlines).
              // HID is still available on hover via the tooltip.
              display: true,
              scaleLabel: { display: false },
              ticks: { display: false, callback: () => '' },
              gridLines: { display: false, drawTicks: false },
            }],
            yAxes: [{
              scaleLabel: { display: true, labelString: cfg.axis },
              gridLines: { color: 'rgba(0,0,0,0.04)' },
              ticks: {
                maxTicksLimit: 8,
                callback: v => {
                  const abs = Math.abs(v);
                  let s;
                  if (abs >= 1e6) s = +(v / 1e6).toFixed(1) + 'J';        // Juta
                  else if (abs >= 1e3) s = +(v / 1e3).toFixed(1) + 'K';   // Ribu
                  else s = v.toLocaleString('ms-MY', { maximumFractionDigits: 2 });
                  return cfg.money ? 'RM ' + s : s;
                },
              },
            }],
          }
        },
        plugins: [boxPlugin],
      });

      this.attachCtrlWheelZoom(ch, canvas);

      this[cfg.inst] = ch;
    },

    // Plain wheel over the chart used to zoom, so scrolling the page stopped dead
    // the moment the cursor crossed a canvas. Gate zoom behind Ctrl instead.
    //
    // chartjs-plugin-zoom@0.7 (Chart.js 2) has no wheelModifierKey option, but it
    // reads options.plugins.zoom.zoom.enabled at event time — so flipping the flag
    // just before its own handler runs is enough. The listener sits on the parent
    // in the CAPTURE phase, which is guaranteed to run before the plugin's
    // listener on the canvas itself.
    attachCtrlWheelZoom(ch, canvas) {
      const container = canvas.parentNode;
      if (!container) return;
      container.addEventListener('wheel', (e) => {
        ch.options.plugins.zoom.zoom.enabled = e.ctrlKey;
        // Ctrl+wheel is the browser's page-zoom shortcut; suppress it so the
        // gesture only zooms the chart.
        if (e.ctrlKey) e.preventDefault();
      }, { capture: true, passive: false });
    },
  },

  beforeDestroy() {
    document.removeEventListener('fullscreenchange', this.onFullscreenChange);
    ['chartH', 'chartQ', 'chartU'].forEach(k => { if (this[k]) this[k].destroy(); });
    clearTimeout(this.drillFilterTimer);
    clearTimeout(this.searchDebounce);
  },
};
</script>

<style scoped>
.julat-harga {
  padding: 16px;
  /* break out of the centered v-container so the content uses full page width */
  margin-left: -12px;
  margin-right: -12px;
}

/* ---------- Bar penapis ----------
   Warna daripada palet yang dikongsi `paparanutama`, sidebar (MenuHeader) dan
   <PageHeader>: teal-700 #037769, wash #eef8f6, hair #dbeeeb. */
.filter-bar {
  background: #f7fcfb;
  border-top: 1px solid #dbeeeb;
  border-bottom: 1px solid #dbeeeb;
}

/* Label penapis — sama gaya dengan `.nav-eyebrow` dalam sidebar. */
.fld__label {
  font-size: var(--fs-3xs);
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #7aa8a2;
  line-height: 1.4;
  margin-bottom: 5px;
  white-space: nowrap;
}

/* Medan outlined: birai teal lembut, menyerlah teal-700 bila fokus. */
.filter-bar ::v-deep .v-input fieldset {
  border-color: #cfeae7;
}
.filter-bar ::v-deep .v-input--is-focused fieldset {
  border-color: #037769 !important;
  border-width: 1px;
}
.filter-bar ::v-deep .v-select__selection--comma {
  color: #21403c;
}
/* Ikon dalam medan (carian, pin, panah dropdown, kosongkan) — prepend juga,
   bukan append sahaja: kedua-dua bar penapis di halaman ini memakai
   `prepend-inner-icon`. */
.filter-bar ::v-deep .v-input__append-inner .v-icon,
.filter-bar ::v-deep .v-input__prepend-inner .v-icon {
  color: #7aa8a2;
}

/* Butang "Tetapkan Semula" — dulu kelabu neutral; kini senada teal. */
.reset-btn.v-btn--outlined {
  border-color: #cfeae7;
  color: #037769;
  letter-spacing: normal;
}
.reset-btn.v-btn--outlined:hover {
  background: #eef8f6;
  border-color: #037769;
}

.pusingan-dash {
  font-size: var(--fs-xs);
  color: #7aa8a2;
}

/* Compact Pusingan From–To range: two narrow number selects on one line */
.pusingan-range .pusingan-sel {
  width: 84px;
  flex: 0 0 84px;
}
.pusingan-range ::v-deep .v-select__selections {
  flex-wrap: nowrap;
}
/* keep the chosen number on one line and never clip it */
.pusingan-range ::v-deep .v-select__selection {
  overflow: visible;
  white-space: nowrap;
}
/* trim inner padding so the number + arrow fit the narrow field */
.pusingan-range ::v-deep .v-input__slot {
  padding: 0 8px !important;
}
.pusingan-range ::v-deep .v-input__append-inner {
  margin-left: 0;
}

/* Section header that replaces the (disabled) single-tab bar */
.section-bar {
  display: flex;
  align-items: center;
  padding: 10px 16px;
  background: #e8f6f5;
  border-left: 4px solid #0EA5A4;
  border-radius: 4px;
}
.section-bar-title {
  font-size: var(--fs-base);
  font-weight: 600;
  color: #037769;
  letter-spacing: .2px;
}

/* Tab bar styled to match the .section-bar banner (used when the Konsensus tab
   is re-enabled). Same teal tint, left accent, and teal active label. */
.iqr-tabs {
  background: #e8f6f5 !important;
  border-left: 4px solid #0EA5A4;
  border-radius: 4px;
}
.iqr-tabs ::v-deep .v-tab {
  font-size: var(--fs-md);
  font-weight: 600;
  letter-spacing: .2px;
  color: #4a8a84 !important;
}
.iqr-tabs ::v-deep .v-tab--active {
  color: #037769 !important;
}

/* search-term highlight in the main table (injected via v-html, so ::v-deep) */
::v-deep mark.kh {
  background: #FFF1A8;
  color: inherit;
  padding: 0 1px;
  border-radius: 2px;
  font-weight: 700;
}

.chart-container {
  position: relative;
  height: 460px;
  width: 100%;
}
/* Ctrl+skrol discoverability hint — same weight as the Mod toggle label so it
   reads as a note, not a control. Hidden on narrow screens where the header
   would wrap. */
.zoom-hint {
  font-size: var(--fs-3xs) !important;
  line-height: 1;
  letter-spacing: .04em;
  white-space: nowrap;
}
@media (max-width: 960px) {
  .zoom-hint { display: none; }
}
/* Mod / Skala-Y toggle group in the chart header */
.chart-toggles { gap: 4px 6px; }
.chart-toggles .overline { font-size: var(--fs-3xs) !important; line-height: 1; letter-spacing: .04em; }
/* Dahulu 10px !important — ia mengatasi saiz butang Vuetify dan mengekalkan
   toggle carta jauh lebih halus daripada kawalan lain. Kini ia hanya membuang
   jarak huruf; saiznya datang daripada saiz butang lalai. */
.chart-toggles .v-btn { letter-spacing: 0; }

/* keep data-table header labels + sort arrows on one line (parallel) */
::v-deep .v-data-table thead th {
  white-space: nowrap;
}

.legend-dot {
  display: inline-block;
  width: 11px;
  height: 11px;
  border-radius: 3px;
  margin-right: 6px;
  flex: 0 0 auto;
}

/* Harga Seunit outlier — the price is unreasonable FOR ITS QUANTITY. Purple so it
   never reads as the red/orange single-value cell flags, and light enough that the
   red RM Negeri / orange Kuantiti text stays legible on top of it. */
::v-deep tr.unit-outlier-row td {
  background: #F3EEFB !important;
}
::v-deep tr.unit-outlier-row td:first-child {
  box-shadow: inset 4px 0 0 #7E57C2;
}
.unit-out-text {
  color: #5E35B1 !important;
}

/* ── Colour key ──────────────────────────────────────────────────────────────
   Button pinned left, legend pushed right by margin-left:auto. justify-content
   on .legend-items keeps every wrapped line right-aligned too — with a v-spacer
   only the FIRST line was right-aligned and the rest fell back to the left. */
.legend-bar {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 8px 16px;
}
.legend-items {
  margin-left: auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 6px 18px;
}
.legend-item {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
}
/* .legend-dot carries a 6px right margin for the formula dialog; here the flex
   gap already spaces it, so drop the margin to avoid a 10px hole. */
.legend-item .legend-dot { margin-right: 0; }
/* full-width, zero-height item = a hard line break in a wrapping flex row */
.legend-break {
  flex: 0 0 100%;
  height: 0;
}
/* "=" rendered as a separator glyph instead of literal text, so the labels line
   up whatever their length */
.legend-sep::before {
  content: '=';
  margin-right: 4px;
  color: #B0BEC5;
}
.legend-fence {
  font-size: var(--fs-3xs);
  color: #78909C;
  background: #F4F6F8;
  border: 1px solid #E3E8EE;
  border-radius: 10px;
  padding: 0 7px;
  line-height: 1.7;
}

/* ── "Why is this row coloured?" callout ─────────────────────────────────── */
/* Flat card: even border all round (no left accent bar) and a soft tint. The icon
   sits in its own rounded badge, which carries the purple cue that the removed
   left border used to provide. */
.why-note {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 14px;
  border: 1px solid #E8E2F6;
  border-radius: 10px;
  background: #FAF8FE;
}
.why-badge {
  flex: 0 0 auto;
  width: 30px;
  height: 30px;
  border-radius: 9px;
  background: #EDE7F6;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.why-body { min-width: 0; }
.why-title {
  font-size: var(--fs-xs);
  font-weight: 700;
  color: #4527A0;
  margin-bottom: 2px;
}
.why-text {
  font-size: var(--fs-xs);
  line-height: 1.55;
  color: #546E7A;
  max-width: 92ch;
}
.why-egs {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 10px;
  margin-top: 7px;
}
.why-eg {
  display: inline-flex;
  align-items: center;
  font-size: var(--fs-3xs);
  font-weight: 600;
  border-radius: 6px;
  padding: 3px 9px;
  white-space: nowrap;
}
.why-eg--ok {
  color: #1B5E20;
  background: #E8F5E9;
  border: 1px solid #C3E6C8;
}
.why-eg--out {
  color: #4527A0;
  background: #F3EEFB;
  border: 1px solid #D9CCF2;
}
@media (max-width: 600px) {
  .why-eg { white-space: normal; }
}

/* pinned / highlighted drill record */
::v-deep tr.pinned-row td {
  background: #FFF8E1 !important;
}
::v-deep tr.pinned-row td:first-child {
  box-shadow: inset 4px 0 0 #FFB300;
}

/* Selected item info banner */
.selected-item-card {
  border: 1px solid #B2DFDB !important;
  border-left: 5px solid #009688 !important;
  background: linear-gradient(90deg, #E0F2F1 0%, #F2FBFA 45%, #FFFFFF 100%) !important;
  box-shadow: 0 3px 14px rgba(0, 150, 136, 0.18) !important;
}
.item-metrics {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 22px;
}
.item-metric { text-align: center; min-width: 84px; }
.im-label {
  font-size: var(--fs-3xs);
  font-weight: 600;
  color: #78909C;
  text-transform: uppercase;
  letter-spacing: .4px;
  margin-bottom: 2px;
}
.im-val { font-size: var(--fs-base); font-weight: 700; line-height: 1.2; }

/* Drill statistics tiles */
.stats-wrap {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 8px;
}
.stat-tile {
  background: #F8FAFC;
  border: 1px solid #E5E9F0;
  border-radius: 8px;
  padding: 8px 10px;
  text-align: center;
}
.stat-label {
  font-size: var(--fs-3xs);
  font-weight: 600;
  color: #546E7A;
  text-transform: uppercase;
  letter-spacing: .4px;
  margin-bottom: 3px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.stat-value {
  font-size: var(--fs-base);
  font-weight: 700;
  line-height: 1.2;
}

/* Chart card in native fullscreen (see toggleFullscreen). The browser sizes the
   element to the screen; we only need to stack the header + chart and let the
   chart take whatever height is left. The card is transparent by default, so it
   needs an explicit background or the fullscreen backdrop shows through black. */
::v-deep .v-card:fullscreen {
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 0;
}
::v-deep .v-card:fullscreen .chart-container {
  flex: 1 1 auto;
  height: auto;
}

/* Formula explainer dialog */
.formula-box {
  background: #F1F8F7;
  border: 1px solid #B2DFDB;
  border-radius: 8px;
  padding: 12px 14px;
}
.formula-steps { padding-left: 18px; margin: 0; }
.formula-steps li { margin-bottom: 2px; line-height: 1.5; }

.metric-block {
  border: 1px solid #E5E9F0;
  border-radius: 8px;
  padding: 12px 14px;
}
.calc-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(96px, 1fr));
  gap: 6px;
}
.calc-cell {
  background: #F8FAFC;
  border: 1px solid #E5E9F0;
  border-radius: 6px;
  padding: 6px 8px;
  text-align: center;
}
.calc-cell .cl {
  display: block;
  font-size: var(--fs-3xs);
  font-weight: 600;
  color: #78909C;
  text-transform: uppercase;
  letter-spacing: .3px;
}
.calc-cell .cv {
  display: block;
  font-size: var(--fs-sm);
  font-weight: 700;
  color: #37474F;
}
.calc-formula {
  background: #FAFAFA;
  border-left: 3px solid #B0BEC5;
  border-radius: 4px;
  padding: 8px 10px;
  line-height: 1.7;
}
</style>
